import React, { useState, useEffect } from 'react';
import './App.css';
import { db, auth, provider } from './firebase'; 
import Lottie from "lottie-react";
import animasyonDosyasi from "./assets/açilis-animasyonu.json"; // JSON dosyanın yolu
// Mevcut satırı bul ve deleteDoc'u ekle:
import { 
  collection, 
  getDocs, 
  addDoc, 
  doc,
  getDoc, 
  setDoc, 
  updateDoc, 
  arrayUnion, 
  arrayRemove, 
  onSnapshot, 
  deleteDoc,
  query,
  where,
  writeBatch,
  serverTimestamp 
} from 'firebase/firestore';

import { 
  signInWithPopup, 
  signOut, 
  onAuthStateChanged, 
  reauthenticateWithPopup, // <-- Bu silme onayı için
  deleteUser,              // <-- Bu silme işlemi için
  GoogleAuthProvider       // <-- EKSİK OLAN BUYDU! (Bunu eklemezsek hata verir)
} from 'firebase/auth';

const TEMEL_MALZEMELER = [
  "tuz", "su", "şeker", "karabiber", "pul biber", "sıvı yağ", 
  "zeytinyağı", "un", "kuru nane", "kekik", "salça", "sarımsak", "soğan", "limon", "sirke", "yoğurt", "mayonez", "ketçap", "hardal", "bal", "tereyağı", "margarin", "süt", "krema", "peynir"
];
function App() {
  // 🔒 ADMİN MAİLİNİ GİR (Kendi mailini buraya yaz)
  const adminListesi = ["kanklcx1903@gmail.com"];

  // --- STATE ---
  // --- ALT TAB BAR İÇİN STATE'LER ---
const [aktifSekme, setAktifSekme] = useState("ana"); // "ana", "favoriler", "alisveris", "ayarlar"

  const [yemekler, setYemekler] = useState([]); 
  const [aramaKelimesi, setAramaKelimesi] = useState(""); // Input'a bağlı (fast)
  const [debounceArama, setDebounceArama] = useState(""); // Filtreleme için (delayed)
  const [secilenTur, setSecilenTur] = useState("Tümü");
  const [secilenYemek, setSecilenYemek] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [secilenMalzemeler, setSecilenMalzemeler] = useState([]); 
  const [filtrePanelAcik, setFiltrePanelAcik] = useState(false);
const [olcuRehberiAcik, setOlcuRehberiAcik] = useState(false); // Gramaj rehberi için
  // En çok kullanılan malzemeleri tutacak sepetimiz
const [populerMalzemeler, setPopulerMalzemeler] = useState([]);
const [panelAcik, setPanelAcik] = useState(false);
const [panelYorumlari, setPanelYorumlari] = useState([]); // Listelenecek yorumlar
const [aktifPanelTab, setAktifPanelTab] = useState("profil"); // 'profil' veya 'admin'
const [sadecePratik, setSadecePratik] = useState(false);
const [aktifYemekYorumlari, setAktifYemekYorumlari] = useState([]);
// Mevcut state'lerin yanına ekle:
const [secilenPorsiyon, setSecilenPorsiyon] = useState(1);  const [malzemeArama, setMalzemeArama] = useState("");
  const [kullanici, setKullanici] = useState(null);
  // 👇 PUANLAMA VE GİRİŞ SİSTEMİ İÇİN GEREKENLER (En tepeye ekle)
 const [acikMenuId, setAcikMenuId] = useState(null);
 // --- ONAY KUTUSU MEKANİZMASI ---
const [onayModal, setOnayModal] = useState({
    goster: false,
    mesaj: "",
    baslik: "⚠️ Dikkat",
    islem: null // Onay verilince çalışacak fonksiyonu burada saklayacağız
});
  const [ilkGirisZorunlu, setIlkGirisZorunlu] = useState(false);
  const [adminSilModali, setAdminSilModali] = useState(false);
  
  const [kullaniciOyu, setKullaniciOyu] = useState(0); // Yıldız puanı
  const [puanHata, setPuanHata] = useState(false);
  
const [sadeceElimdekiler, setSadeceElimdekiler] = useState(false);

  
  const [yorumMetni, setYorumMetni] = useState("");    // Yazılan yorum
  const [yorumModalAcik, setYorumModalAcik] = useState(false); // Yorum penceresi
const [aktifKategori, setAktifKategori] = useState(null); // "🥬 Sebze" yerine null
// // Eski "silmeOnayi" yerine bu ikisini kullanacağız:
const [silmeAsamasi, setSilmeAsamasi] = useState(0); // 0: Kapalı, 1: Emin misin?, 2: Google Uyarısı
const [silmeHataMesaji, setSilmeHataMesaji] = useState(""); // Hataları burada göstereceğiz
  const [favoriler, setFavoriler] = useState([]); 
  const [sadeceFavoriler, setSadeceFavoriler] = useState(false);
  const [bildirim, setBildirim] = useState(null);
  const [opaklik, setOpaklik] = useState(1);
  const [hafifEsnekMod, setHafifEsnekMod] = useState(false);
// Başlangıç değerini localStorage'dan okuyarak belirliyoruz
const [geceModu, setGeceModu] = useState(() => {
  return localStorage.getItem('geceModu') === 'true';
});


// Gece modu her değiştiğinde localStorage'a da yazıyoruz
useEffect(() => {
  localStorage.setItem('geceModu', geceModu);
  const body = document.body;
  if (geceModu) body.classList.add('dark-mode');
  else body.classList.remove('dark-mode');
}, [geceModu]);

// 🚀 ARAMA DEBOUNCE (Yazı yazarken filtreleme hafifletmek için)
useEffect(() => {
  const timer = setTimeout(() => {
    setDebounceArama(aramaKelimesi);
  }, 300); // 300ms sonra güncelle

  // Cleanup: Yeni yazı gelmeden önceki timer'ı iptal et
  return () => clearTimeout(timer);
}, [aramaKelimesi]); // aramaKelimesi değişince tetikleniyor

  // ⚙️ MENU & AYARLAR
  const [profilMenuAcik, setProfilMenuAcik] = useState(false);
  const [profilAcik, setProfilAcik] = useState(false);
  
 const paylas = async (yemek) => {
  console.log("Paylaşılan Yemek:", yemek);

  // ⚠️ İD kontrolü (yemekler koleksiyonundaki ID'yi kullan)
  const tarifId = yemek.id || yemek.docId;
  if (!tarifId || String(tarifId).trim() === "") {
    bildirimGoster("Hata: Tarif ID bulunamadı. Admin ile iletişime geç.", "hata");
    console.error("Paylaş Hatası: ID boş -", yemek);
    return;
  }

  // Linki oluşturuyoruz
  const ozelLink = `${window.location.origin}/?recipeId=${tarifId}`;

  // 👇 İŞTE SİHİRLİ DOKUNUŞ: Linki mesaj metninin içine de ekliyoruz!
  const paylasimMetni = `Bu tarifi mutlaka denemelisin: ${yemek.ad} 😋\n\nTarife buradan bakabilirsin:\n${ozelLink}`;

  if (navigator.share) {
    try {
      await navigator.share({
        title: `Elimde Ne Var? - ${yemek.ad}`,
        text: paylasimMetni, // Linki artık metnin içinde gönderiyoruz
        url: ozelLink        // Bazı cihazlar için bunu da bırakıyoruz
      });
    } catch (err) {
      console.log('Paylaşım iptal edildi');
    }
  } else {
    // Bilgisayarda ise panoya kopyala
    navigator.clipboard.writeText(paylasimMetni);
    bildirimGoster("Tarif linki kopyalandı! 📋");
  }
};
  // YENİ: Kullanıcı Sağlık Verileri
  const [kullaniciAyarlari, setKullaniciAyarlari] = useState({ 
    diyet: "Yok", 
    sevilmeyenler: [], // Artık dizi (array) olarak tutacağız
    ozelResim: "", // Kullanıcı özel resim koymak isterse
    yas: "",
    boy: "",
    kilo: "",
    cinsiyet: "Erkek",
    hedef: "Koru" // Kilo Ver, Koru, Al
  });

// --- PANELİ AÇ VE VERİLERİ GETİR ---
const panelVerileriniGetir = async () => {
  if (!kullanici) return;
  setPanelAcik(true); // Modalı aç
  setPanelYorumlari([]); // Önce temizle

  try {
    let q;
    
    // EĞER ADMIN SEKME AÇIKSA VE KULLANICI ADMIN İSE:
    if (aktifPanelTab === 'admin' && adminListesi.includes(kullanici.email)) {
      // Sadece şikayet edilenleri getir
      q = query(collection(db, "comments"), where("isReported", "==", true));
    } 
    // YOKSA (NORMAL PROFİL):
    else {
      // Sadece benim yorumlarımı getir
      q = query(collection(db, "comments"), where("userId", "==", kullanici.uid));
    }

    const snapshot = await getDocs(q);
    const veriler = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setPanelYorumlari(veriler);

  } catch (error) {
    console.error("Panel Hatası:", error);
  }
};

const onayIste = (mesaj, calisacakFonksiyon, baslik = "⚠️ Emin misin?") => {
    setOnayModal({
        goster: true,
        mesaj: mesaj,
        baslik: baslik,
        islem: () => calisacakFonksiyon() // Fonksiyonu paketleyip saklıyoruz
    });
};

// Kutuda "Evet" denilince bu çalışır
const onayiOnayla = () => {
    if (onayModal.islem) {
        onayModal.islem(); // Saklanan asıl kodu çalıştır
    }
    setOnayModal({ ...onayModal, goster: false }); // Kutuyu kapat
};

 
// eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
  const baslat = async () => {
    // 1. URL'den ID'yi al
    const params = new URLSearchParams(window.location.search);
    const gelenId = params.get('recipeId');

    console.log("🔍 URL Kontrol ediliyor... ID:", gelenId);
    console.log("📋 localStorage yasalUyariOnayi:", localStorage.getItem('yasalUyariOnayi'));

    if (gelenId) {
      // ID'yi hafızaya al (Onaydan sonra kullanmak için)

      // Yasal uyarı kontrolü
      const onay = localStorage.getItem('yasalUyariOnayi');
      
      if (onay === 'true') {
        console.log("✅ Onay var, tarif direkt getiriliyor...", gelenId);
        // Async olması için await'li çağır
        const basarili = await tarifGetir(gelenId);
        console.log("🎯 Tarif yükleme sonucu:", basarili);
      } else {
        console.log("⚠️ Onay yok, yasal uyarı açılıyor...");
        setIlkGirisZorunlu(true); // Uyarıyı aç
      }
    } else {
        // Link yoksa sadece onayı kontrol et
        const onay = localStorage.getItem('yasalUyariOnayi');
        console.log("📄 Başta modalda: Onay dur?", onay !== 'true');
        if (onay !== 'true') {
            setIlkGirisZorunlu(true);
        }
    }
  };

  baslat();
}, []);



// 👇 TARİFİ VERİTABANINDAN ÇEKEN FONKSİYON (DÜZELTILMIŞ VERSİYON)
const tarifGetir = async (id) => {
  try {
    console.log("🔥 Firebase'e soruluyor: ID =", id, "Tipi:", typeof id);
    
    if (!id || String(id).trim() === "") {
      console.warn("⚠️ Tarif ID boş veya invalid!");
      bildirimGoster("Tarif ID bulunamadı!", "hata");
      return false;
    }
    
    const idString = String(id);
    console.log("📋 Araştırılacak ID (String):", idString);
    
    // Önce "yemekler" koleksiyonunda ara (varsayılan)
    console.log("🔎 Adım 1: 'yemekler' koleksiyonunda aranıyor...");
    let docRef = doc(db, "yemekler", idString); 
    let docSnap = await getDoc(docRef);
    console.log("📦 'yemekler' sonucu:", docSnap.exists() ? "BULUNDU ✅" : "Bulunamadı ❌");

    // Eğer yemekler'te yoksa recipes'e bak (Yedek plan)
    if (!docSnap.exists()) {
       console.log("🔎 Adım 2: 'recipes' koleksiyonunda aranıyor...");
       docRef = doc(db, "recipes", idString);
       docSnap = await getDoc(docRef);
       console.log("📦 'recipes' sonucu:", docSnap.exists() ? "BULUNDU ✅" : "Bulunamadı ❌");
    }

    if (docSnap.exists()) {
      const veri = docSnap.data();
      console.log("🎉 TARİF BULUNDU:", veri.ad);
      
      // ŞİMDİ EKRANI AÇIYORUZ
      const yemekData = { id: docSnap.id, ...veri };
      setSecilenYemek(yemekData);
      bildirimGoster(`${veri.ad} tarifi açılıyor... 🍽️`, "basari");
      return true; // Başarılı
      
    } else {
      console.error("⛔ HATA: ID'li hiçbir tarif bulunamadı!");
      console.error("   🔍 Aranan ID:", idString);
      console.error("   📂 Kontrol edilen koleksiyonlar: 'yemekler', 'recipes'");
      bildirimGoster("Tarif bulunamadı. Link kontrol edin veya admin ile iletişime geçin.", "hata");
      return false;
    }
  } catch (error) {
    console.error("❌ Firebase Bağlantı Hatası:", error);
    console.error("   📋 Hata mesajı:", error.message);
    console.error("   🔐 Hata kodu:", error.code);
    bildirimGoster("Tarif yüklenirken hata oluştu! Firebase bağlantısını kontrol edin.", "hata");
    return false;
  }
};
// -----------------------------------------------------------------------
  // 1. PANEL AÇILINCA YORUMLARI ÇEKEN KOD (BUNU MUTLAKA EKLE)
  // -----------------------------------------------------------------------
 useEffect(() => { 
    // Sadece panel açıksa ve kullanıcı giriş yapmışsa çalışır
    if (panelAcik && kullanici) {
      const verileriGetir = async () => {
        try {
          let q;
          
          if (aktifPanelTab === 'admin') {
             // Admin ise TÜM yorumları getir (veya şikayet edilenleri)
             // Şimdilik hepsini getiriyoruz, istersen where ile filtreleriz
             q = query(collection(db, "comments"));
          } else {
             // Normal kullanıcı ise SADECE KENDİ yorumlarını getir
             q = query(
               collection(db, "comments"), 
               where("userId", "==", kullanici.uid) 
             );
          }

          const querySnapshot = await getDocs(q);
          const gelenYorumlar = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));

          // Tarihe göre sırala (En yeni en üstte)
          gelenYorumlar.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

          setPanelYorumlari(gelenYorumlar);
          
        } catch (error) {
          console.error("Yorumlar çekilirken hata:", error);
        }
      };

      verileriGetir();
    }
  }, [panelAcik, kullanici, aktifPanelTab]); // Bu değişkenler değişince tekrar çalışır
// eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
  if(panelAcik) {
    panelVerileriniGetir();
  }
}, [aktifPanelTab, panelAcik]); // Sekme değişince tetiklenir
  

 // -----------------------------------------------------------------------
  // ✅ YORUM GÖNDERME (BİLDİRİMLİ VERSİYON)
  // -----------------------------------------------------------------------
  const yorumGonder = async (e) => {
    if (e) e.preventDefault(); 

    // 1. KULLANICI KONTROLÜ
    if (!kullanici) {
      bildirimGoster("Yorum yapmak için önce giriş yapmalısınız! 🔒", "hata");
      setYorumModalAcik(false);
      return;
    }

    // ---------------------------------------------------------
    // 🛡️ YENİ EKLENEN: ÇOKLU YORUM ENGELLEME
    // ---------------------------------------------------------
    const zatenYorumYapmis = aktifYemekYorumlari.some(y => y.userId === kullanici.uid);
    
    if (zatenYorumYapmis) {
      bildirimGoster("Bu tarife zaten yorum yaptınız! Sadece bir yorum hakkınız var. ✋", "hata");
      setYorumModalAcik(false); // Modal'ı kapatalım ki ısrar etmesin :)
      return;
    }
    // ---------------------------------------------------------

    // 2. BOŞ ALAN KONTROLÜ
    if (!yorumMetni.trim() || kullaniciOyu === 0) {
      bildirimGoster("Lütfen puan verip yorum yazın! ⭐", "hata");
      return;
    }

    try {
      // 3. FIREBASE'E KAYIT
      await addDoc(collection(db, "comments"), {
        text: yorumMetni,
        rating: kullaniciOyu,
        recipeId: String(secilenYemek.id),
        recipeName: secilenYemek.ad,
        userId: kullanici.uid,
        userName: kullanici.displayName || kullanici.email.split('@')[0],
        userPhoto: kullanici.photoURL || "",
        createdAt: serverTimestamp(),
        isReported: false 
      });

      bildirimGoster("Yorumunuz başarıyla gönderildi! 🎉", "basari");
      
      // Temizlik işlemleri
      setYorumMetni("");
      setKullaniciOyu(0);
      setYorumModalAcik(false); 

    } catch (error) {
      console.error("Yorum Hatası:", error);
      bildirimGoster("Yorum gönderilemedi: " + error.message, "hata");
    }
};


// 👇 BU KODU App.js İÇİNDEKİ DİĞER useEffect'LERİN ALTINA YAPIŞTIR 👇
// eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
  // 1. Önce URL'de ID var mı diye bak
  const params = new URLSearchParams(window.location.search);
  const urlId = params.get('recipeId');

  // 2. Eğer URL'de ID varsa VE Yasal Uyarı ekranda DEĞİLSE (Onaylıysa)
  if (urlId && !ilkGirisZorunlu) {
      console.log("🔗 Link Algılandı ve Onay Tamam, Tarif Getiriliyor:", urlId);
      
      // Tarifi getir (Eğer zaten açık değilse)
      // (Burada küçük bir kontrol yapıyoruz ki sürekli istek atmasın)
      if (!secilenYemek || secilenYemek.id !== urlId) {
          tarifGetir(urlId);
      }
  }
}, [ilkGirisZorunlu]); // <--- BU SATIR ÇOK ÖNEMLİ

// -----------------------------------------------------------------------
  // 🟢 YEMEK DETAYI İÇİN YORUMLARI GETİR (GÜNCELLENMİŞ VERSİYON)
  // -----------------------------------------------------------------------
 useEffect(() => {
    // 1. Eğer panel kapalıysa veya yemek seçilmediyse işlem yapma
    if (!secilenYemek) return;

    // 2. Veritabanındaki "comments" tablosuna bağlan
    const yorumlarRef = collection(db, "comments");
    
    // 3. ŞU ANKİ yemeğin ID'sine sahip yorumları süz
    // ⚠️ ÖNEMLİ: ID'yi String'e çeviriyoruz çünkü veritabanında tırnak içinde ("5") kayıtlı.
    const q = query(
        yorumlarRef, 
        where("recipeId", "==", String(secilenYemek.id)) 
    );

    // 4. Canlı Dinleme (Yeni yorum gelince anında ekrana düşer)
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const gelenVeriler = snapshot.docs.map(doc => {
        const data = doc.data();
        
        // Veritabanındaki veriyi senin yazdığın koda uygun hale getiriyoruz:
        return {
          id: doc.id,
          text: data.text,           // Senin kodunda {yorum.text} var -> Eşleşti ✅
          rating: data.rating,       // Senin kodunda {yorum.rating} var -> Eşleşti ✅
          userName: data.userName,   // Senin kodunda {yorum.userName} var -> Eşleşti ✅
          userId: data.userId,       // Senin kodunda {yorum.userId} var -> Eşleşti ✅
          createdAt: data.createdAt  // Senin kodunda {yorum.createdAt} var -> Eşleşti ✅
        };
      });

      // Yorumları tarihe göre sırala (En yeni en üstte)
      gelenVeriler.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));

      setAktifYemekYorumlari(gelenVeriler); // Listeyi doldur
    });

    // Temizlik (Sayfadan çıkınca dinlemeyi durdur)
    return () => unsubscribe();

  }, [secilenYemek]); // Sadece yeni bir yemek seçince çalışır

// -----------------------------------------------------------------------
  // 🟢 YORUMLARI GETİREN ANA MOTOR (Bunu Yapıştırınca Çalışacak)
  // -----------------------------------------------------------------------


// --- YORUM SİLME (Admin veya Yorum Sahibi) ---
// -----------------------------------------------------------------------
  // ✅ GÜZELLEŞTİRİLMİŞ SİLME İŞLEMİ
  // -----------------------------------------------------------------------
  const yorumSil = (id) => {
    // 1. Standart pencere yerine bizim özel fonksiyonu çağırıyoruz
    onayIste(
        "Bu yorumu silmek istediğine emin misin? 🗑️", // Mesaj
        async () => { // --- KULLANICI "EVET" DERSE BURASI ÇALIŞACAK ---
            try {
                // Firebase'den silme işlemi
                await deleteDoc(doc(db, "comments", id));
                
                // Senin güzel bildirim (Toast)
                bildirimGoster("Yorum başarıyla silindi! 👋", "basari");

                // Listeyi ekrandan da anında silmek için filtreleme
                setPanelYorumlari(prev => prev.filter(y => y.id !== id));
                setAktifYemekYorumlari(prev => prev.filter(y => y.id !== id));

            } catch (error) {
                console.error("Silme hatası:", error);
                bildirimGoster("Silinirken hata oluştu.", "hata");
            }
        }, 
        "Yorum Silinecek" // Başlık (Kutunun tepesinde yazar)
    );
};

  
 

  // 📝 FORM & DÜZENLEME
  const [formAcik, setFormAcik] = useState(false);
  // Hakkında penceresinin açık/kapalı durumu
const [hakkindaAcik, setHakkindaAcik] = useState(false);
  const [aktifDuzenlemeId, setAktifDuzenlemeId] = useState(null);
  
  // Mevcut satırı şununla değiştir:
const [formVerisi, setFormVerisi] = useState({
  ad: '', sure: '', zorluk: 'Kolay', maliyet: 'Ucuz',
  kalori: '', protein: '', karbonhidrat: '', yag: '', // <--- YENİ EKLENENLER
  kisiSayisi: '', resim: '', video: '',
  kategori: "Ana Yemek",
  malzemelerStr: '', yapilisStr: '', ogunler: [], diyetler: []
});





// TAM BURAYA YAPIŞTIR 👇
const yorumBildir = async (yorum) => {
  if (!kullanici) return bildirimGoster("Bildirmek için giriş yapmalısın!", "hata");

  try {
    const yorumRef = doc(db, "comments", yorum.id);

    await updateDoc(yorumRef, { 
      isReported: true,
      
      // 1. ŞİKAYET EDEN (Butona şu an basan SEN)
      bildirenKullaniciEmail: kullanici.email,
      bildirenKullaniciIsim: kullanici.displayName || "İsimsiz Kullanıcı",
      
      // 2. YORUMUN SAHİBİ (Orijinal yorumdaki veriyi koruyoruz)
      // Bu sayede admin panelinde "y.userName" dersen sahibi, 
      // "y.bildirenKullaniciEmail" dersen şikayetçi görünür.
      sikayetEdilenKullanici: yorum.userName || "Bilinmiyor",
      
      bildirimTarihi: serverTimestamp() 
    });

    bildirimGoster("Yorum incelemeye alındı. Teşekkürler! 🙏", "basari");
    setAcikMenuId(null);
  } catch (error) {
    console.error("Firebase Hata Detayı:", error);
    bildirimGoster("Bildirilirken bir hata oluştu.", "hata");
  }
};

  
  const ogunSecenekleri = ["Kahvaltı", "Öğle", "Akşam", "Ara Öğün"];
  const diyetSecenekleri = ["Glutensiz", "Vegan", "Vejetaryen", "Yüksek Protein", "Diyet (Fit)"];
  const maliyetSecenekleri = ["Ucuz", "Orta", "Pahalı"];

  // --- DATABASE & AUTH ---
  // --- DATABASE & CACHE ---
useEffect(() => {
  let mounted = true;
  let timeout1, timeout2;

  const CACHE_SURESI = 30 * 60 * 1000;

  const ekranAc = (hizli = false) => {
    const bekleme = hizli ? 1200 : 3500;

    timeout1 = setTimeout(() => {
      if (!mounted) return;
      setOpaklik(0);
      timeout2 = setTimeout(() => {
        if (mounted) setYukleniyor(false);
      }, 500);
    }, bekleme);
  };

  const verileriGetir = async () => {
    try {
      const cacheRaw = localStorage.getItem("yemekler_cache");
      if (cacheRaw) {
        const cache = JSON.parse(cacheRaw);
        if (Date.now() - cache.zaman < CACHE_SURESI) {
          setYemekler(cache.veriler);
          ekranAc(true);
          return;
        }
      }
    } catch {
      localStorage.removeItem("yemekler_cache");
    }

    try {
      const snap = await getDocs(collection(db, "yemekler"));
      const yeniVeriler = snap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }));

      if (!mounted) return;

      setYemekler(yeniVeriler);
      localStorage.setItem(
        "yemekler_cache",
        JSON.stringify({ veriler: yeniVeriler, zaman: Date.now() })
      );

      ekranAc(false);
    } catch (err) {
      console.error(err);
      setYukleniyor(false);
    }
  };

  verileriGetir();

  return () => {
    mounted = false;
    clearTimeout(timeout1);
    clearTimeout(timeout2);
  };
}, []);

  useEffect(() => {
    // Cebimizde "silindi" notu var mı?
    const silindiMi = localStorage.getItem("silmeIslemiBasarili");

    if (silindiMi === "true") {
      // Varsa, o güzel bildirimi göster
      bildirimGoster("👋 Hesabın ve tüm verilerin başarıyla silindi. Seni özleyeceğiz!", "basari"); // Veya 'hata' rengi istersen onu yaz
      
      // Notu hemen yok et ki, kullanıcı sayfayı her yenilediğinde tekrar çıkmasın
      localStorage.removeItem("silmeIslemiBasarili");
    }
  }, []);
  // --- POPÜLER MALZEMELERİ HESAPLA ---
  useEffect(() => {
    if (yemekler.length === 0) return; // 'tumYemekler' yerine 'yemekler' kullandık

    const frekansTablosu = {};

    yemekler.forEach(yemek => {
      if (yemek.malzemeler) {
        Object.keys(yemek.malzemeler).forEach(malzeme => {
          const ad = malzeme.trim(); 
          frekansTablosu[ad] = (frekansTablosu[ad] || 0) + 1;
        });
      }
    });

    // En çok geçen 15 malzemeyi seç
    const siraliListe = Object.entries(frekansTablosu)
      .sort(([, sayiA], [, sayiB]) => sayiB - sayiA)
      .map(([ad]) => ad)
      .slice(0, 30);

    setPopulerMalzemeler(siraliListe);

  }, [yemekler]); // Yemek listesi değiştikçe çalışır

  

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setKullanici(currentUser);
      if (currentUser) {
        const ref = doc(db, "kullanicilar", currentUser.uid);
        onSnapshot(ref, (snap) => {
          if (snap.exists()) {
            const data = snap.data();
            setFavoriler(data.favoriYemekler || []);
            // Veritabanından ayarları çek, yoksa varsayılanı kullan
            setKullaniciAyarlari({ 
              diyet: data.diyet || "Yok", 
              sevilmeyenler: data.sevilmeyenler || [], 
              ozelResim: data.ozelResim || "",
              yas: data.yas || "",
              boy: data.boy || "",
              kilo: data.kilo || "",
              cinsiyet: data.cinsiyet || "Erkek",
              hedef: data.hedef || "Koru"
            });
          } else { setDoc(ref, { favoriYemekler: [] }); }
        });
      } else { setFavoriler([]); }
    });
    return () => unsubscribe();
  }, []);

  // --- FONKSİYONLAR ---
  const bildirimGoster = (mesaj, tur = "basari") => {
    setBildirim({ mesaj, tur }); setTimeout(() => setBildirim(null), 3000);
  };

  const getYoutubeId = (url) => {
    if (!url) return null;
    const match = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/);
    return (match && match[2].length === 11) ? match[2] : null;
  }

const girisYap = async () => { 
    try { 
      // Sadece giriş yap, ekstra parametre yok, temiz.
      await signInWithPopup(auth, provider); 
      bildirimGoster("Giriş Başarılı! Hoş geldin.", "basari");
    } catch (error) { 
      console.error(error); 
    } 
  };
  const cikisYap = async () => { 
    try {
      await signOut(auth); 
      // Hafızayı temizlemek için sayfayı yenile
      window.location.reload(); 
    } catch (error) {
      console.error("Çıkış hatası:", error);
    }
  };

// --- HESAP SİLME FONKSİYONU (GÜVENLİ VERSİYON) ---
 const hesabiSil = async () => {
    setSilmeHataMesaji(""); // Önceki hataları temizle

    if (!auth.currentUser) return;

    try {
      const provider = new GoogleAuthProvider();
      // Google penceresini açmadan önce kullanıcıya haber verdik (UI kısmında), şimdi işlemi yapıyoruz:
      await reauthenticateWithPopup(auth.currentUser, provider);

      // --- Eğer buraya geldiyse doğru hesabı seçmiş demektir ---
      
      // 1. Veritabanındaki verisini sil
      const kullaniciRef = doc(db, "kullanicilar", auth.currentUser.uid);
      await deleteDoc(kullaniciRef);

      // 2. Auth hesabını sil
      await deleteUser(auth.currentUser);

      // 3. Çıkış yap ve temizle
      setKullanici(null);
      setProfilAcik(false);
      setSilmeAsamasi(0);
      // Başarı durumunda ufak bir bildirim (bunu da modal yapabilirsin ama şimdilik alert kalsın, zaten sayfa yenilenecek)
      localStorage.setItem("silmeIslemiBasarili", "true");

      // 2. Sayfayı yenile (Sayfa açılınca yukarıdaki notu okuyup bildirim verecek)
      window.location.reload();


    } catch (error) {
      console.error("Hata:", error);

      // --- ÖZEL HATA YÖNETİMİ ---
      if (error.code === 'auth/user-mismatch') {
        setSilmeHataMesaji(`⚠️ Hata: Farklı bir hesap seçtiniz! Lütfen şu an giriş yapmış olduğunuz "${auth.currentUser.email}" hesabını seçin.`);
      } else if (error.code === 'auth/popup-closed-by-user') {
        setSilmeHataMesaji("İşlemi iptal ettiniz (Pencere kapatıldı).");
      } else {
        setSilmeHataMesaji("Bir hata oluştu: " + error.message);
      }
    }
  };
  const toggleFavori = async (e, yemekId) => {
    e.stopPropagation();
    if (!kullanici) return bildirimGoster("Giriş yapmalısın!", "hata");
    const ref = doc(db, "kullanicilar", kullanici.uid);
    if (favoriler.includes(yemekId)) await updateDoc(ref, { favoriYemekler: arrayRemove(yemekId) });
    else await updateDoc(ref, { favoriYemekler: arrayUnion(yemekId) });
  };

const ayarlariKaydet = async () => {
  if (!kullanici) return;
  try {
    await updateDoc(doc(db, "kullanicilar", kullanici.uid), kullaniciAyarlari);
    bildirimGoster("Profil Güncellendi! ✅");
    setProfilAcik(false);
  } catch { 
    bildirimGoster("Kaydedilemedi.", "hata"); 
  }
};
  // --- 🧮 VKİ VE KALORİ HESAPLAMA ---
  const hesaplaSaglikVerileri = () => {
    if(!kullaniciAyarlari.yas || !kullaniciAyarlari.boy || !kullaniciAyarlari.kilo) return null;
    
    const kilo = parseFloat(kullaniciAyarlari.kilo);
    const boy = parseFloat(kullaniciAyarlari.boy); // cm cinsinden
    const yas = parseFloat(kullaniciAyarlari.yas);
    
    // VKİ Hesabı: kg / (m * m)
    const boyMetre = boy / 100;
    const vki = (kilo / (boyMetre * boyMetre)).toFixed(1);
    
    let vkiDurumu = "";
    if(vki < 18.5) vkiDurumu = "Zayıf";
    else if(vki < 25) vkiDurumu = "Normal";
    else if(vki < 30) vkiDurumu = "Kilolu";
    else vkiDurumu = "Obez";

    // Bazal Metabolizma (Harris-Benedict)
    let bmr = 0;
    if (kullaniciAyarlari.cinsiyet === "Erkek") {
      bmr = 88.36 + (13.4 * kilo) + (4.8 * boy) - (5.7 * yas);
    } else {
      bmr = 447.6 + (9.2 * kilo) + (3.1 * boy) - (4.3 * yas);
    }

    // Hedefe Göre Kalori (Hareketsiz yaşam varsayımı x1.2)
    let gunlukKalori = bmr * 1.2; 
    
    if (kullaniciAyarlari.hedef === "Ver") gunlukKalori -= 500;
    else if (kullaniciAyarlari.hedef === "Al") gunlukKalori += 500;

    return { vki, vkiDurumu, gunlukKalori: Math.round(gunlukKalori) };
  };

  const saglikSonuc = hesaplaSaglikVerileri();

  // --- FORM İŞLEMLERİ ---
  const duzenlemeyiBaslat = (yemek) => {
    setAktifDuzenlemeId(yemek.id);
    let malzStr = "";
    if (yemek.malzemeler) Object.entries(yemek.malzemeler).forEach(([k, v]) => malzStr += `${k}: ${v}\n`);
    let yapilisStr = (yemek.yapilisAdimlari || []).join('\n');

   setFormVerisi({
  ad: yemek.ad, 
  sure: yemek.sure, 
  zorluk: yemek.zorluk, 
  maliyet: yemek.maliyet || 'Orta',
  kalori: yemek.kalori,
  // --- BURASI EKSİK OLABİLİR, DİKKAT ---
  protein: yemek.protein || '',       
  karbonhidrat: yemek.karbonhidrat || '',
  yag: yemek.yag || '',
  // -------------------------------------
  kisiSayisi: yemek.kisiSayisi, 
  resim: yemek.resim, 
  video: yemek.video || '',
  malzemelerStr: malzStr, 
  yapilisStr: yapilisStr,
  ogunler: yemek.ogunler || [], 
  diyetler: yemek.diyetler || []
});
    setSecilenYemek(null); 
    setFormAcik(true); 
  };

  const yemekKaydet = async (e) => {
  e.preventDefault();

  if (!kullanici || !adminListesi.includes(kullanici.email)) return;

  const malzemelerMap = {};
  const malzemelerRaw = (formVerisi.malzemelerStr || "");
  malzemelerRaw.split('\n').forEach(s => {
    const [a, m] = s.split(':');
    if (a?.trim()) {
      malzemelerMap[a.trim().toLowerCase()] = m?.trim() || "Göz kararı";
    }
  });

  const yapilisArray = (formVerisi.yapilisStr || '')
    .split('\n')
    .filter(s => s.trim() !== '');

  const yeniVeri = {
    ...formVerisi,
    sure: Number(formVerisi.sure),
    kalori: Number(formVerisi.kalori),
    protein: Number(formVerisi.protein) || 0,
    karbonhidrat: Number(formVerisi.karbonhidrat) || 0,
    yag: Number(formVerisi.yag) || 0,
    kisiSayisi: Number(formVerisi.kisiSayisi),
    malzemeler: malzemelerMap,
    yapilisAdimlari: yapilisArray,
    tarih: new Date()
  };

  try {
    if (aktifDuzenlemeId) {
      await updateDoc(doc(db, 'yemekler', aktifDuzenlemeId), yeniVeri);
      bildirimGoster("Güncellendi! 🔄");
    } else {
      await addDoc(collection(db, 'yemekler'), {
        ...yeniVeri,
        ekleyen: kullanici.email
      });
      bildirimGoster("Eklendi! 🎉");
    }

    // 🔥 Cache invalidate
    localStorage.removeItem("yemekler_cache");

    // 🧼 UI temizle
    setFormAcik(false);
    
    // 👇 BUNU GERİ AÇMALISIN:
    setTimeout(() => window.location.reload(), 1000);

  } catch (error) {
    console.error(error);
    bildirimGoster("Hata oluştu!", "hata");
  }
};

// 🗑️ TARİF SİLME FONKSİYONU
  const yemekSil = async (id) => {
    if (!window.confirm("Bu tarifi kalıcı olarak silmek istediğine emin misin?")) return;

    try {
      await deleteDoc(doc(db, "yemekler", id));
      // Listeden de anında kaldır (sayfa yenilemeye gerek kalmasın)
      setYemekler(prev => prev.filter(y => y.id !== id));
      setSecilenYemek(null); // Modalı kapat
      bildirimGoster("Tarif başarıyla silindi 👋");
    } catch (error) {
      console.error(error);
      bildirimGoster("Silinirken hata oluştu!", "hata");
    }
  };

// 🧨 TÜM YEMEKLERİ SİLME (ADMİN ÖZEL)
 // --- SİLME FONKSİYONU (En üstte, diğer fonksiyonların yanına) ---
const tumYemekleriSil = async () => {
    if (!adminListesi.includes(kullanici?.email)) return;

    try {
      // Toplu silme işlemi başlatılıyor
      const batch = writeBatch(db); 
      const querySnapshot = await getDocs(collection(db, "yemekler"));

      // Her bir yemeği silme listesine ekle
      querySnapshot.forEach((doc) => {
        batch.delete(doc.ref);
      });

      // İşlemi onayla ve veritabanına gönder
      await batch.commit();
      
      // 🔥 Cache'i temizle
      localStorage.removeItem("yemekler_cache");
      
      // Ekranı temizle
      setYemekler([]);
      bildirimGoster("🧹 Tüm yemek tarifleri başarıyla silindi!");
      
      // Sayfayı yenile
      setTimeout(() => window.location.reload(), 1500);
      
    } catch (error) {
      console.error("Silme işlemi sırasında hata:", error);
      bildirimGoster("Silinirken bir hata oluştu: " + error.message, "hata");
    }
  };
// 📥 YEDEK ALMA (VERİ İNDİRME) FONKSİYONU
const verileriIndir = () => {
  if (yemekler.length === 0) {
    bildirimGoster("İndirilecek veri yok!", "hata");
    return;
  }
  const jsonVerisi = JSON.stringify(yemekler, null, 2);
  const blob = new Blob([jsonVerisi], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `yemek_yedegi_${new Date().toLocaleDateString()}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  bildirimGoster("Yedek dosyası indirildi! 📥");
};

 // 📂 DOSYADAN TOPLU YÜKLEME FONKSİYONU (FİNAL)
const dosyaYukle = (e) => {
  const dosya = e.target.files[0];
  if (!dosya) return;

  const reader = new FileReader();
  reader.onload = async (event) => {
    try {
      const yuklenecekVeriler = JSON.parse(event.target.result);
      
      if (!Array.isArray(yuklenecekVeriler)) {
        bildirimGoster("Hata: Dosya formatı liste [] olmalı!", "hata");
        return;
      }

      // --- ONAY MEKANİZMASI ---
      onayIste(
        `${yuklenecekVeriler.length} adet tarif yüklenecek. Onaylıyor musun?`, 
        async () => { 
          try {
            setYukleniyor(true); // Ekranı kilitle
            let sayac = 0;

            // 🔄 DÖNGÜ BAŞLIYOR (Tüm tarifleri tek tek yükle)
            for (const yemek of yuklenecekVeriler) {
                
                // Türkçe karakter uyumlu ID oluşturma (Daha güvenli)
                const yemekId = yemek.ad
                    .toLowerCase()
                    .trim()
                    .replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's')
                    .replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ç/g, 'c')
                    .replace(/\s+/g, '-')
                    .replace(/[^a-z0-9-]/g, '');

                const temizVeri = {
                    ad: yemek.ad.trim(),
                    sure: Number(yemek.sure) || 0,
                    kalori: Number(yemek.kalori) || 0,
                    protein: Number(yemek.protein) || 0,
                    karbonhidrat: Number(yemek.karbonhidrat) || 0,
                    yag: Number(yemek.yag) || 0,
                    zorluk: yemek.zorluk || "Kolay",
                    maliyet: yemek.maliyet || "Orta",
                    kisiSayisi: Number(yemek.kisiSayisi) || 2,
                    resim: yemek.resim || "https://via.placeholder.com/300?text=Resim+Yok",
                    video: yemek.video || "",
                    // Malzemeler map olarak geliyorsa direkt al, yoksa boş obje
                    malzemeler: yemek.malzemeler || {}, 
                    yapilisAdimlari: Array.isArray(yemek.yapilisAdimlari) ? yemek.yapilisAdimlari : [],
                    ogunler: Array.isArray(yemek.ogunler) ? yemek.ogunler : [],
                    diyetler: Array.isArray(yemek.diyetler) ? yemek.diyetler : [],
                    ekleyen: kullanici.email,
                    tarih: new Date()
                };

                // Veritabanına yaz
                await setDoc(doc(db, 'yemekler', yemekId), temizVeri);
                sayac++;
            }
            // 🏁 DÖNGÜ BİTTİ

            // ⭐ KRİTİK NOKTA: Döngü bittiği an eski hafızayı siliyoruz!
            localStorage.removeItem("yemekler_cache");

            bildirimGoster(`Başarılı! ${sayac} tarif sisteme işlendi 🚀`, "basari");
            
            // Yeni listeyi görmek için sayfayı yenile
            setTimeout(() => window.location.reload(), 1500);

          } catch (error) {
            console.error("Yükleme Hatası:", error);
            bildirimGoster("Yükleme sırasında hata oluştu!", "hata");
          } finally {
            setYukleniyor(false); // Kilidi aç
          }
        },
        "Toplu Yükleme Onayı"
      );

    } catch (parseError) {
      console.error("JSON Hatası:", parseError);
      bildirimGoster("Dosya okunamadı veya format hatalı!", "hata");
    }
  };

  reader.readAsText(dosya);
};
  const handleCheckbox = (tip, deger) => {
    setFormVerisi(p => { const l = p[tip]||[]; return l.includes(deger)?{...p,[tip]:l.filter(i=>i!==deger)}:{...p,[tip]:[...l,deger]}; });
  };

  const rastgeleYemekGetir = () => {
    if (filtrelenmisYemekler.length > 0) {
      const sansliYemek = filtrelenmisYemekler[Math.floor(Math.random() * filtrelenmisYemekler.length)];
      setSecilenYemek(sansliYemek);
    } else {
      bildirimGoster("Listede yemek yok!", "hata");
    }
  };

  // --- FİLTRELEME & DATA ---
  const tumMalzemeler = Array.from(new Set(yemekler.flatMap(y => Object.keys(y.malzemeler || {})))).sort();
  // 🟢 BURAYA YAPIŞTIR (Mantık Kodu)
  const filtrelenmisMalzemelerListesi = tumMalzemeler.filter(m => 
    m.toLocaleLowerCase('tr').includes(malzemeArama.toLocaleLowerCase('tr')) && 
    !kullaniciAyarlari.sevilmeyenler.includes(m)
  );
 const filtrelenmisYemekler = React.useMemo(() => {
    return yemekler.filter((yemek) => {
      // 🔍 1. KESİN ARAMA MOTORU (DEBOUNCE ile optimize)
      const arananTemiz = debounceArama.toLowerCase().trim(); // ← debounceArama kullan
      let metinUyumu = true;

      if (arananTemiz.length > 0) {
        // Kelimeleri parçala (virgül veya boşluğa göre)
        const anahtarKelimeler = arananTemiz.split(/[\s,]+/).filter(k => k.length > 0);
        
        // Sadece İsim ve Malzemelerin İSİMLERİNDE ara (Süre, kalori vb. katma ki "30" yazınca "tuz" çıkmasın)
        // Malzemelerin sadece anahtarlarını (adlarını) alıyoruz.
        const tarifIcerigi = (
          yemek.ad + " " + 
          Object.keys(yemek.malzemeler || {}).join(" ")
        ).toLowerCase();

        // 🔥 KRİTİK DEĞİŞİKLİK: .some() yerine .every()
        // Kullanıcının yazdığı TÜM kelimeler tarifte geçmek ZORUNDA.
        metinUyumu = anahtarKelimeler.every(kelime => tarifIcerigi.includes(kelime));
      }
      

      
      // 2. Diğer Filtreler
      const turUyumu = secilenTur === "Tümü" || (yemek.ogunler || []).includes(secilenTur);
     

      // --- MALZEME UYUMU (TAMAMEN DÜZELTİLMİŞ) ---
const yemekMalzemeListesi = Object.keys(yemek.malzemeler || {}).map(m => m.toLowerCase());

let malzemeUyumu = true;

// Eğer malzeme seçildiyse veya arama yapıldıysa kontrol et
if (secilenMalzemeler.length > 0) {
  
  const tumGirdiler = [
    ...secilenMalzemeler.map(m => m.toLowerCase()),
  ];
  // Kritik malzemeleri (temel olmayanlar) ayır
  const kritikMalzemeler = yemekMalzemeListesi.filter(m => 
    !TEMEL_MALZEMELER.some(temel => m.includes(temel.toLowerCase()))
  );

  // Kullanıcının GİRDİĞİ malzemeler tarifte var mı?
  const girilenlerTarifte = tumGirdiler.every(girdi => 
    yemekMalzemeListesi.some(ym => ym.includes(girdi))
  );

  // Tarifte eksik olan kritik malzemeler
  const eksikler = kritikMalzemeler.filter(kritik => 
    !tumGirdiler.some(girdi => kritik.includes(girdi))
  );

  // MODLARA GÖRE KARAR
  if (sadeceElimdekiler) {
    // SIKI MOD: Girdiğim malzemeler tarifte olmalı VE eksik olmamalı
    malzemeUyumu = girilenlerTarifte && eksikler.length === 0;
  } else if (hafifEsnekMod) {
    // HAFİF MOD: Girdiğim malzemeler olmalı + maksimum 1 eksik
    malzemeUyumu = girilenlerTarifte && eksikler.length <= 1;
  } else {
    // MODLAR KAPALI: Sadece girdiğim malzemeler tarifte olsun
    malzemeUyumu = girilenlerTarifte;
  }

  // Eksikleri karta gösterebilmek için kaydet
  yemek.eksikGirdiler = eksikler;
} else {
  // Hiçbir şey seçilmemişse/yazılmamışsa tüm tarifler geçerli
  malzemeUyumu = true;
}
      const favoriUyumu = !sadeceFavoriler || favoriler.includes(yemek.id);
      let profilUyumu = true;
      if (kullaniciAyarlari.diyet !== "Yok" && !yemek.diyetler?.includes(kullaniciAyarlari.diyet)) profilUyumu = false;
      
      // --- DÜZELTİLEN KISIM BAŞLANGIÇ ---
      if (kullaniciAyarlari.sevilmeyenler.length > 0 && profilUyumu) {
        // Yasaklı listesini küçük harfe çevirip temizleyelim
        const yasaklar = kullaniciAyarlari.sevilmeyenler.map(s => s.toLowerCase().trim());
        

        // Yemeğin malzemelerini alalım (Sadece isimleri)
        const yemekMalzemeleri = Object.keys(yemek.malzemeler || {}).map(m => m.toLowerCase().trim());

        // KONTROL: Eğer yemeğin malzemelerinden HERHANGİ BİRİ, yasaklı listesinde geçiyorsa...
        const yasakliVarMi = yemekMalzemeleri.some(malzeme => 
           yasaklar.some(yasak => malzeme.includes(yasak) || yasak.includes(malzeme))
        );

        if (yasakliVarMi) profilUyumu = false;
      }
      const pratikUyumu = !sadecePratik || (Number(yemek.sure) > 0 && Number(yemek.sure) <= 30 && yemek.zorluk === "Kolay");      // --- DÜZELTİLEN KISIM BİTİŞ ---
      return metinUyumu && turUyumu && malzemeUyumu && favoriUyumu && profilUyumu && pratikUyumu;
    });
  },[yemekler, debounceArama, secilenTur, sadecePratik, secilenMalzemeler, sadeceFavoriler, favoriler, kullaniciAyarlari, sadeceElimdekiler,hafifEsnekMod]);
 // 💲 MALİYET İKONU VE YAZISI (GÜNCELLENDİ)
 const maliyetIcon = (m) => {
    const deger = m || "Ucuz"; 
    
    // Sadece semboller döndürüyoruz, yazı yok
    if(deger === 'Pahalı') return <span className="cost-badge red" title="Yüksek Maliyet">₺₺₺</span>;
    if(deger === 'Orta') return <span className="cost-badge orange" title="Orta Maliyet">₺₺</span>;
    
    // Varsayılan
    return <span className="cost-badge green" title="Ekonomik">₺</span>;
  }

  // Profil Resmi Seçimi (Google mı Özel mi?)
  const profilResmiGoster = () => {
    if (kullaniciAyarlari.ozelResim) return kullaniciAyarlari.ozelResim;
    return kullanici?.photoURL;
  }

 if (yukleniyor) {
  return (
    <div className="loading-screen" style={{
      // Pozisyon ayarları (Tam ekran kaplaması için)
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 9999,
      
      // İçerik ortalama
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#ffffff',
      
      // --- GEÇİŞ EFEKTİ ---
      opacity: opaklik, // State'ten gelen değer (1 başlar, 0 olur)
      transition: 'opacity 0.5s ease-out' // Yarım saniyede solar
    }}>
      
      {/* Lottie Animasyonu */}
      <div style={{ width: '250px', height: '250px' }}>
        <Lottie animationData={animasyonDosyasi} loop={true} />
      </div>

      {/* Yazı */}
      <p style={{ marginTop: '20px', fontWeight: 'bold', color: '#4CAF50' }}>
        Tarifler Hazırlanıyor...
      </p>
    </div>
  );
}

  return (
    <div className={`App ${geceModu ? 'dark' : ''}`}>
      {bildirim && <div className={`toast ${bildirim.tur}`}>{bildirim.mesaj}</div>}

      <div className="header">
       <h1>
  Elimde Ne Var? 
  <img src="/logo192.png" alt="Logo" className="header-logo" />
</h1>
        <div style={{display:'flex', gap:'15px', alignItems:'center'}}>
         
          
          {kullanici ? (
            <div className="user-profile-container" style={{position: 'relative'}}>
              <img src={profilResmiGoster()} alt="Profil" className="profile-pic-btn" onClick={() => setProfilMenuAcik(!profilMenuAcik)}/>
              
             {profilMenuAcik && (
  <div className="dropdown-menu">
    {saglikSonuc && <div className="menu-info">🎯 Hedef: {saglikSonuc.gunlukKalori} kcal</div>}
    
    {/* 1. Ayarlar Butonu */}
<div className="menu-item" onClick={() => { 
  setProfilAcik(true); 
  setProfilMenuAcik(false); 
}}>
  ⚙️ Ayarlar & Hedefler
</div> 
    {/* 👇 YENİ EKLEDİĞİMİZ SATIR BURASI 👇 */}
    <div className="menu-item" onClick={() => { setHakkindaAcik(true); setProfilMenuAcik(false); }}>ℹ️ Hakkında &Yasal Uyarı</div>
    
    {/* 3. Çıkış Yap Butonu */}
    <div className="menu-item logout" onClick={cikisYap}>🚪 Çıkış Yap</div>
  </div>
)}
            </div>
          ) : (<button onClick={girisYap} className="login-btn">Giriş Yap</button>)}
        </div>
      </div>

     {/* ANA SAYFA SEKMESİ - KONTROLLER + TARİFLER */}
{aktifSekme === "ana" && (
  <>
    {/* KONTROLLER */}
    <div className="controls">
      <div className="search-area" style={{marginBottom:'10px'}}>
        <div style={{display:'flex', justifyContent:'center', gap:'10px', alignItems:'center'}}>
          
          {/* ARAMA ÇUBUĞU */}
          <input 
            type="text" 
            placeholder="Yemek veya malzeme ara..." 
            className="search-bar" 
            value={aramaKelimesi}
            onChange={(e) => setAramaKelimesi(e.target.value)} 
          />
          
          {/* ŞANS BUTONU */}
          <button onClick={rastgeleYemekGetir} className="dice-btn" title="Rastgele Yemek">🎲</button>
          
          {/* ⚙️ FİLTRE BUTONU */}
          <button 
            onClick={() => setFiltrePanelAcik(!filtrePanelAcik)} 
            className={`dice-btn ${filtrePanelAcik ? 'active-filter' : ''}`}
            style={{backgroundColor: filtrePanelAcik ? '#2c3e50' : '#f1f2f6', color: filtrePanelAcik ? 'white' : '#333'}}
            title="Detaylı Filtre & Araçlar"
          >
            ⚙️
          </button>
        </div>

        {/* FİLTRE ÇEKMECESİ */}
        {filtrePanelAcik && (
          <div className="filter-drawer">
            
            {/* MODLAR */}
            <div style={{ marginTop: '15px', display: 'flex', gap: '8px', width: '100%' }}>
              
              {/* SIKI MOD */}
              <div 
                onClick={() => {
                  const yeni = !sadeceElimdekiler;
                  setSadeceElimdekiler(yeni);
                  if (yeni) setHafifEsnekMod(false);
                }}
                style={{
                  flex: 1, display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center',
                  padding: '12px 8px', borderRadius: '12px', cursor: 'pointer',
                  transition: '0.3s',
                  backgroundColor: sadeceElimdekiler ? '#eefbf3' : '#f8f9fa',
                  border: sadeceElimdekiler ? '2px solid #2ecc71' : '1px solid #eee'
                }}
              >
                <span style={{ fontSize: '0.75rem', fontWeight: 'bold', marginBottom: '8px', textAlign: 'center' }}>
                  🏠 Elimde Ne Varsa
                </span>
                <div style={{
                  width: '40px', height: '22px', borderRadius: '15px', position: 'relative', transition: '0.3s',
                  backgroundColor: sadeceElimdekiler ? '#2ecc71' : '#cbd5e0'
                }}>
                  <div style={{
                    width: '16px', height: '16px', backgroundColor: 'white', borderRadius: '50%',
                    position: 'absolute', top: '3px', transition: '0.3s',
                    left: sadeceElimdekiler ? '21px' : '3px'
                  }} />
                </div>
              </div>

              {/* HAFİF MOD */}
              <div 
                onClick={() => {
                  const yeni = !hafifEsnekMod;
                  setHafifEsnekMod(yeni);
                  if (yeni) setSadeceElimdekiler(false);
                }}
                style={{
                  flex: 1, display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center',
                  padding: '12px 8px', borderRadius: '12px', cursor: 'pointer',
                  transition: '0.3s',
                  backgroundColor: hafifEsnekMod ? '#fffaf0' : '#f8f9fa',
                  border: hafifEsnekMod ? '2px solid #ed8936' : '1px solid #eee'
                }}
              >
                <span style={{ fontSize: '0.75rem', fontWeight: 'bold', marginBottom: '8px', textAlign: 'center' }}>
                  🤏 +1 Eksik Malzeme
                </span>
                <div style={{
                  width: '40px', height: '22px', borderRadius: '15px', position: 'relative', transition: '0.3s',
                  backgroundColor: hafifEsnekMod ? '#ed8936' : '#cbd5e0'
                }}>
                  <div style={{
                    width: '16px', height: '16px', backgroundColor: 'white', borderRadius: '50%',
                    position: 'absolute', top: '3px', transition: '0.3s',
                    left: hafifEsnekMod ? '21px' : '3px'
                  }} />
                </div>
              </div>
            </div>

            {/* TEMİZLE BUTONU */}
            <div style={{marginTop: '15px'}}>
              <button 
                onClick={() => {
                  setSecilenMalzemeler([]);
                  setAramaKelimesi("");
                  setSadeceElimdekiler(false);
                  setHafifEsnekMod(false);
                  bildirimGoster("Filtreler temizlendi! 🧹", "basari");
                }}
                style={{
                  width: '100%', padding: '12px', backgroundColor: '#e74c3c',
                  color: 'white', border: 'none', borderRadius: '8px',
                  fontWeight: 'bold', cursor: 'pointer', fontSize: '0.95rem'
                }}
              >
                🧹 Tüm Filtreleri Temizle
              </button>
            </div>

            {/* GRAMAJ REHBERİ */}
            <div style={{textAlign:'center', marginTop: '10px'}}>
              <button 
                className="helper-link" 
                onClick={() => setOlcuRehberiAcik(true)}
                style={{
                  background: 'none', border: 'none', color: '#3498db',
                  textDecoration: 'underline', cursor: 'pointer', fontSize: '0.9rem'
                }}
              >
                ℹ️ Gramaj & Ölçü Rehberi
              </button>
            </div>
          </div>
        )}
      </div>
              
      {kullaniciAyarlari.diyet !== "Yok" && (
        <div className="active-filter-alert">⚡ Sadece {kullaniciAyarlari.diyet} tarifler</div>
      )}
              
      {/* KATEGORİLİ MALZEME SEÇİCİ */}
{(() => {
  const MALZEME_KATEGORILERI = {
  "🥬 Sebze": { 
    renk: "#27ae60", acik: "#eafaf1", 
    malzemeler: [
      { ad: "domates", emoji: "🍅" },
      { ad: "soğan", emoji: "🧅" },
      { ad: "patates", emoji: "🥔" },
      { ad: "biber", emoji: "🌶️" },
      { ad: "sarımsak", emoji: "🧄" },
      { ad: "havuç", emoji: "🥕" },
      { ad: "kabak", emoji: "🥒" },
      { ad: "patlıcan", emoji: "🍆" },
      { ad: "ıspanak", emoji: "🌿" },
      { ad: "marul", emoji: "🥬" },
      { ad: "salatalık", emoji: "🥒" },
      { ad: "mantar", emoji: "🍄" },
      { ad: "maydanoz", emoji: "🌿" },
      { ad: "dereotu", emoji: "🌱" },
      { ad: "nane", emoji: "🌿" },
      { ad: "limon", emoji: "🍋" }
    ]
  },
  "🥩 Et/Balık": { 
    renk: "#e74c3c", acik: "#fdf2f2", 
    malzemeler: [
      { ad: "tavuk", emoji: "🍗" },
      { ad: "kıyma", emoji: "🥩" },
      { ad: "kuşbaşı", emoji: "🥩" },
      { ad: "balık", emoji: "🐟" },
      { ad: "sosis", emoji: "🌭" },
      { ad: "sucuk", emoji: "🌭" },
      { ad: "dana eti", emoji: "🥩" },
      { ad: "kuzu eti", emoji: "🍖" },
      { ad: "ton balığı", emoji: "🐟" },
      { ad: "karides", emoji: "🦐" }
    ]
  },
  "🧀 Süt/Yumurta": { 
    renk: "#f39c12", acik: "#fef9e7", 
    malzemeler: [
      { ad: "yumurta", emoji: "🥚" },
      { ad: "süt", emoji: "🥛" },
      { ad: "peynir", emoji: "🧀" },
      { ad: "yoğurt", emoji: "🥛" },
      { ad: "tereyağı", emoji: "🧈" },
      { ad: "krema", emoji: "🍶" },
      { ad: "beyaz peynir", emoji: "🧀" },
      { ad: "kaşar", emoji: "🧀" }
    ]
  },
  "🌾 Tahıl/Bakliyat": { 
    renk: "#e67e22", acik: "#fef5ec", 
    malzemeler: [
      { ad: "un", emoji: "🌾" },
      { ad: "pirinç", emoji: "🍚" },
      { ad: "makarna", emoji: "🍝" },
      { ad: "bulgur", emoji: "🌾" },
      { ad: "ekmek", emoji: "🍞" },
      { ad: "nohut", emoji: "🫘" },
      { ad: "mercimek", emoji: "🫘" },
      { ad: "fasulye", emoji: "🫘" },
      { ad: "yulaf", emoji: "🌾" },
      { ad: "irmik", emoji: "🌾" }
    ]
  },
  "🧂 Baharat/Diğer": { 
    renk: "#8e44ad", acik: "#f5eef8", 
    malzemeler: [
      { ad: "tuz", emoji: "🧂" },
      { ad: "karabiber", emoji: "🌑" },
      { ad: "pul biber", emoji: "🌶️" },
      { ad: "kekik", emoji: "🌿" },
      { ad: "kimyon", emoji: "🌰" },
      { ad: "zerdeçal", emoji: "🟡" },
      { ad: "tarçın", emoji: "🟤" },
      { ad: "salça", emoji: "🥫" },
      { ad: "sıvı yağ", emoji: "🫗" },
      { ad: "zeytinyağı", emoji: "🫒" },
      { ad: "sirke", emoji: "🍶" },
      { ad: "şeker", emoji: "🍬" }
    ]
  }
};

  const kategoriler = Object.keys(MALZEME_KATEGORILERI);

  return (
    <div style={{ marginBottom: '10px' }}>

      {/* SEÇİLİ MALZEMELER */}
      {secilenMalzemeler.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', padding: '8px 0', marginBottom: '8px' }}>
          {secilenMalzemeler.map(m => {
            // Hangi kategoride olduğunu bul, o rengi kullan
            const kategoriRenk = Object.values(MALZEME_KATEGORILERI).find(k => k.malzemeler.some(item => item.ad === m))?.renk || '#2ecc71';
            const emoji = Object.values(MALZEME_KATEGORILERI).flatMap(k => k.malzemeler).find(item => item.ad === m)?.emoji || '';
            return (
              <span key={m} onClick={() => setSecilenMalzemeler(p => p.filter(i => i !== m))}
                style={{
                  backgroundColor: kategoriRenk, color: 'white',
                  padding: '5px 12px', borderRadius: '20px',
                  fontSize: '0.82rem', cursor: 'pointer',
                  display: 'flex', alignItems: 'center', gap: '5px', fontWeight: 'bold',
                  boxShadow: `0 2px 6px ${kategoriRenk}55`
                }}>
                {emoji} {m} ✕
              </span>
            );
          })}
          <span onClick={() => setSecilenMalzemeler([])}
            style={{
              backgroundColor: '#e74c3c', color: 'white',
              padding: '5px 12px', borderRadius: '20px',
              fontSize: '0.82rem', cursor: 'pointer', fontWeight: 'bold'
            }}>
            🧹 Temizle
          </span>
        </div>
      )}

      {/* KATEGORİLER - ACCORDION */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {kategoriler.map(kat => {
          const { renk, acik, malzemeler } = MALZEME_KATEGORILERI[kat];
          const buKategoriAcik = aktifKategori === kat;
          const buKategorideSecili = malzemeler.filter(({ ad }) => secilenMalzemeler.includes(ad)).length;

          return (
            <div key={kat} style={{
              borderRadius: '12px',
              border: `2px solid ${buKategoriAcik ? renk : '#eee'}`,
              overflow: 'hidden',
              transition: '0.2s'
            }}>
              
              {/* KATEGORİ BAŞLIĞI (Tıklanınca açılır/kapanır) */}
              <div onClick={() => setAktifKategori(buKategoriAcik ? null : kat)}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '10px 14px', cursor: 'pointer',
                  backgroundColor: buKategoriAcik ? acik : 'white',
                  transition: '0.2s'
                }}>
             
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0, flex: 1 }}>
                  <span style={{ fontSize: '1.1rem' }}>{kat}</span>
                  {buKategorideSecili > 0 && (
                    <span style={{
                      backgroundColor: renk, color: 'white',
                      borderRadius: '10px', padding: '1px 8px',
                      fontSize: '0.75rem', fontWeight: 'bold'
                    }}>
                      {buKategorideSecili}
                    </span>
                  )}
                </div>
                <span style={{
                  fontSize: '0.9rem', color: renk, fontWeight: 'bold',
                  transform: buKategoriAcik ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: '0.3s', display: 'inline-block'
                }}>▼</span>
              </div>

              {/* MALZEMELEr (Sadece açıksa görünür) */}
              {buKategoriAcik && (
                <div style={{
                  display: 'flex', flexWrap: 'wrap', gap: '7px',
                  padding: '10px 14px 14px',
                  backgroundColor: acik,
                  borderTop: `1px solid ${renk}33`
                }}>
                  {malzemeler.map(({ ad, emoji }) => {
  const secili = secilenMalzemeler.includes(ad);
  return (
    <span key={ad}
      onClick={() => setSecilenMalzemeler(p => p.includes(ad) ? p.filter(i => i !== ad) : [...p, ad])}
      style={{
        padding: '6px 13px', borderRadius: '20px', cursor: 'pointer',
        fontSize: '0.85rem', fontWeight: secili ? 'bold' : 'normal',
        transition: '0.2s',
        backgroundColor: secili ? renk : 'white',
        color: secili ? 'white' : '#444',
        border: `1.5px solid ${secili ? renk : '#ddd'}`,
        boxShadow: secili ? `0 2px 8px ${renk}44` : 'none'
      }}>
      {emoji} {ad} {secili ? '✕' : '+'}
    </span>
  );
})}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
})()}

      {/* FİLTRE BUTONLARI */}
      <div className="filter-buttons">
        
        {/* PRATİK MODU */}
        <button 
          onClick={() => setSadecePratik(!sadecePratik)}
          className="filter-btn"
          style={{
            backgroundColor: sadecePratik ? '#fbc02d' : '#fff', 
            color: sadecePratik ? '#fff' : '#fbc02d', 
            border: '2px solid #fbc02d',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            minWidth: '120px',
            justifyContent: 'center'
          }}
        >
          <span>⚡</span>
          <span>{sadecePratik ? 'Pratik: AÇIK' : 'Pratik: KAPALI'}</span>
        </button>

        {/* ÖĞÜNLER */}
        {["Tümü", "Kahvaltı", "Öğle", "Akşam", "Ara Öğün"].map(t => (
          <button 
            key={t} 
            onClick={() => {
              setSecilenTur(t); 
              setSadeceFavoriler(false);
            }} 
            className={`filter-btn ${secilenTur === t ? 'active' : ''}`}
          >
            {t}
          </button>
        ))}
        
        {/* FAVORİLER */}
        {kullanici && (
          <button 
            onClick={() => setSadeceFavoriler(!sadeceFavoriler)} 
            className={`filter-btn fav ${sadeceFavoriler ? 'active' : ''}`}
          >
            ❤️ Favoriler
          </button>
        )}
      </div>
    </div>

    {/* TARİFLER */}
    <div className="yemek-listesi">
      {filtrelenmisYemekler.map((yemek) => (
        <div key={yemek.id} className="yemek-kart" onClick={() => {
          setSecilenYemek(yemek);
          setSecilenPorsiyon(Number(yemek.kisiSayisi) || 1);
        }}>
          <button onClick={(e) => toggleFavori(e, yemek.id)} className="fav-icon">
            {favoriler.includes(yemek.id) ? '❤️' : '🤍'}
          </button>

          <img 
            src={yemek.resim && yemek.resim.trim() !== "" ? yemek.resim : "https://dummyimage.com/400x300/e0e0e0/666666&text=Resim+Yok"} 
            alt={yemek.ad} 
            onError={(e) => { 
              e.target.onerror = null; 
              e.target.src = "https://dummyimage.com/400x300/e0e0e0/666666&text=Resim+Bulunamadi"; 
            }} 
          />
          
          <div className="yemek-bilgi">
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'5px'}}>
              <h3 style={{margin:0, fontSize:'1.1rem'}}>{yemek.ad}</h3>
              {maliyetIcon(yemek.maliyet)}
            </div>
            
            {hafifEsnekMod && yemek.eksikGirdiler?.length === 1 && (
              <div style={{
                backgroundColor: '#fffaf0',
                borderLeft: '4px solid #ed8936',
                padding: '5px 10px',
                marginTop: '8px',
                borderRadius: '4px'
              }}>
                <small style={{ color: '#c05621', fontWeight: 'bold', display: 'block' }}>
                  🤏 Sadece 1 Malzeme Eksik:
                </small>
                <span style={{ fontSize: '0.85rem', color: '#7b341e' }}>
                  {yemek.eksikGirdiler[0]}
                </span>
              </div>
            )}
            
            <div className="card-meta">
              <span>⏱️ {yemek.sure} dk</span>
              <span className="divider">•</span>
              <span style={{
                fontWeight:'bold', 
                color: (saglikSonuc && yemek.kalori > (saglikSonuc.gunlukKalori / 3)) ? '#d63031' : 'inherit'
              }}>
                🔥 {yemek.kalori} kcal
              </span>
              <span className="divider">•</span>
              <span className={`zorluk-badge ${yemek.zorluk.toLowerCase()}`}>
                {yemek.zorluk}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  </>
)}  {/* ← ANA SAYFA KAPANIŞ (TEK KAPANIŞ) */}

     
{/* İÇERİK ALANI - FAVORİLER */}
{aktifSekme === "favoriler" && (
  <div className="yemek-listesi">
    {yemekler.filter(y => favoriler.includes(y.id)).length === 0 ? (
      <div style={{textAlign:'center', padding:'50px', color:'#999'}}>
        <p style={{fontSize:'3rem'}}>❤️</p>
        <p>Henüz favori tarifiniz yok</p>
        <small>Beğendiğiniz tarifleri ❤️ ile işaretleyin</small>
      </div>
    ) : (
      yemekler.filter(y => favoriler.includes(y.id)).map((yemek) => (
        <div key={yemek.id} className="yemek-kart" onClick={() => {
          setSecilenYemek(yemek);
          setSecilenPorsiyon(Number(yemek.kisiSayisi) || 1);
        }}>
          <button onClick={(e) => toggleFavori(e, yemek.id)} className="fav-icon">
            {favoriler.includes(yemek.id) ? '❤️' : '🤍'}
          </button>
          <img 
            src={yemek.resim || "https://dummyimage.com/400x300/e0e0e0/666666&text=Resim+Yok"} 
            alt={yemek.ad} 
            onError={(e) => { 
              e.target.onerror = null; 
              e.target.src = "https://dummyimage.com/400x300/e0e0e0/666666&text=Resim+Bulunamadi"; 
            }} 
          />
          <div className="yemek-bilgi">
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'5px'}}>
              <h3 style={{margin:0, fontSize:'1.1rem'}}>{yemek.ad}</h3>
              {maliyetIcon(yemek.maliyet)}
            </div>
            <div className="card-meta">
              <span>⏱️ {yemek.sure} dk</span>
              <span className="divider">•</span>
              <span style={{
                fontWeight:'bold', 
                color: (saglikSonuc && yemek.kalori > (saglikSonuc.gunlukKalori / 3)) ? '#d63031' : 'inherit'
              }}>
                🔥 {yemek.kalori} kcal
              </span>
              <span className="divider">•</span>
              <span className={`zorluk-badge ${yemek.zorluk.toLowerCase()}`}>
                {yemek.zorluk}
              </span>
            </div>
          </div>
        </div>
      ))
    )}
  </div>
)}



{/* İÇERİK ALANI - AYARLAR */}
{aktifSekme === "ayarlar" && (
  kullanici ? (
    <div style={{
      padding: '20px',
      maxWidth: '600px',
      margin: '0 auto',
      paddingBottom: '100px'
    }}>
      
      {/* ========================================
          1. PROFİL & HEDEFLER (MEVCUT)
          ======================================== */}
      <div style={{marginBottom:'40px', paddingBottom:'30px', borderBottom:'2px solid #eee'}}>
        <h2>👤 Profil & Hedefler</h2>
        
        <div className="settings-section">
          <h3>1. Kişisel Bilgiler</h3>
          <div className="form-group">
            <label>Profil Resmi (URL)</label>
            <input 
              type="text" 
              placeholder="Örn: https://resim.com/ben.jpg" 
              value={kullaniciAyarlari.ozelResim} 
              onChange={(e) => setKullaniciAyarlari({...kullaniciAyarlari, ozelResim: e.target.value})} 
            />
            <small>Boş bırakırsan Google resmin görünür.</small>
          </div>
          
          <div style={{
  display: 'flex', 
  flexWrap: 'wrap', // Sığmadığında aşağı kaydırır
  gap: '10px',
  justifyContent: 'space-between'
}}>
  <div style={{flex: '1 1 calc(33% - 10px)', minWidth: '100px'}}>
    <label style={{fontSize:'0.75rem', color:'#666', display:'block', marginBottom:'4px'}}>Yaş</label>
    <input type="number" value={kullaniciAyarlari.yas} onChange={(e)=>setKullaniciAyarlari({...kullaniciAyarlari, yas:e.target.value})}
      style={{width:'100%', padding:'8px 6px', borderRadius:'8px', border:'1px solid #ddd', fontSize:'0.9rem'}}/>
  </div>
  
  <div style={{flex: '1 1 calc(33% - 10px)', minWidth: '100px'}}>
    <label style={{fontSize:'0.75rem', color:'#666', display:'block', marginBottom:'4px'}}>Boy (cm)</label>
    <input type="number" value={kullaniciAyarlari.boy} onChange={(e)=>setKullaniciAyarlari({...kullaniciAyarlari, boy:e.target.value})}
      style={{width:'100%', padding:'8px 6px', borderRadius:'8px', border:'1px solid #ddd', fontSize:'0.9rem'}}/>
  </div>

  <div style={{flex: '1 1 calc(33% - 10px)', minWidth: '100px'}}>
    <label style={{fontSize:'0.75rem', color:'#666', display:'block', marginBottom:'4px'}}>Kilo (kg)</label>
    <input type="number" value={kullaniciAyarlari.kilo} onChange={(e)=>setKullaniciAyarlari({...kullaniciAyarlari, kilo:e.target.value})}
      style={{width:'100%', padding:'8px 6px', borderRadius:'8px', border:'1px solid #ddd', fontSize:'0.9rem'}}/>
  </div>
</div>
          
          <div className="form-group" style={{ marginBottom: '15px' }}>
  <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '5px', color: '#555' }}>
    Cinsiyet
  </label>
  <select
    value={kullaniciAyarlari.cinsiyet}
    onChange={(e) => setKullaniciAyarlari({ ...kullaniciAyarlari, cinsiyet: e.target.value })}
    style={{
      width: '100%',
      padding: '10px',
      borderRadius: '10px',
      border: '1px solid #ddd',
      backgroundColor: '#fff',
      fontSize: '1rem'
    }}
  >
    <option>Erkek</option>
    <option>Kadın</option>
  </select>
</div>

<div className="form-group" style={{ marginBottom: '20px' }}>
  <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', marginBottom: '5px', color: '#555' }}>
    🎯 Hedefin Ne?
  </label>
  <select
    value={kullaniciAyarlari.hedef}
    onChange={(e) => setKullaniciAyarlari({ ...kullaniciAyarlari, hedef: e.target.value })}
    style={{
      width: '100%',
      padding: '10px',
      borderRadius: '10px',
      border: '1px solid #ddd',
      backgroundColor: '#fff',
      fontSize: '1rem'
    }}
  >
    <option value="Koru">Kilomu Koru</option>
    <option value="Ver">Kilo Ver (-500 kcal)</option>
    <option value="Al">Kilo Al (+500 kcal)</option>
  </select>
</div>

{saglikSonuc && (
  <div className="health-card" style={{
    marginTop: '20px',
    padding: '20px',
    background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', // Yeşilimsi ferah bir renk
    borderRadius: '15px',
    color: '#1a4731',
    boxShadow: '0 10px 20px rgba(0,0,0,0.05)',
    textAlign: 'center'
  }}>
    <p style={{ margin: '5px 0' }}>📊 VKİ: <b>{saglikSonuc.vki}</b> ({saglikSonuc.vkiDurumu})</p>
    <p style={{ margin: '5px 0', fontSize: '1.1rem' }}>🔥 Günlük Hedef: <b>{saglikSonuc.gunlukKalori} kcal</b></p>
  </div>
)}
        </div>
        
        <div className="settings-section">
          <h3>2. Tercihler</h3>
          
          <div className="form-group">
            <label style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <span>🌙 Gece Modu</span>
              <div 
                onClick={() => {
                  const yeniDeger = !geceModu;
                  setGeceModu(yeniDeger);
                  localStorage.setItem('geceModu', String(yeniDeger));
                }}
                style={{
                  width: '50px', height: '26px', borderRadius: '15px', position: 'relative',
                  cursor: 'pointer', transition: '0.3s',
                  backgroundColor: geceModu ? '#2c3e50' : '#cbd5e0'
                }}
              >
                <div style={{
                  width: '20px', height: '20px', backgroundColor: 'white', borderRadius: '50%',
                  position: 'absolute', top: '3px', transition: '0.3s',
                  left: geceModu ? '27px' : '3px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }} />
              </div>
            </label>
            <small>Göz yorgunluğunu azaltmak için karanlık tema</small>
          </div>
          
          <div className="form-group">
            <label>Özel Diyet</label>
            <select 
              value={kullaniciAyarlari.diyet} 
              onChange={(e) => setKullaniciAyarlari({...kullaniciAyarlari, diyet: e.target.value})}
            >
              <option value="Yok">Yok</option>
              {diyetSecenekleri.map(d => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          
          <div className="form-group">
            <label>🚫 Sevmediğim Malzemeler</label>
            <div className="combobox-container">
              <div className="selected-tags">
                {kullaniciAyarlari.sevilmeyenler.length === 0 && (
                  <span style={{fontSize:'0.8rem', color:'#999'}}>Henüz seçim yapmadınız.</span>
                )}
                {kullaniciAyarlari.sevilmeyenler.map((malzeme) => (
                  <span 
                    key={malzeme} 
                    className="tag-chip" 
                    onClick={() => {
                      const yeniListe = kullaniciAyarlari.sevilmeyenler.filter(i => i !== malzeme);
                      setKullaniciAyarlari({...kullaniciAyarlari, sevilmeyenler: yeniListe});
                    }}
                  >
                    {malzeme} ✖
                  </span>
                ))}
              </div>

              <input 
                type="text" 
                placeholder="Malzeme ara... (Örn: Soğan)" 
                value={malzemeArama}
                onChange={(e) => setMalzemeArama(e.target.value)}
                className="modal-input search-input"
              />

              {malzemeArama && (
                <ul className="dropdown-list">
                  {filtrelenmisMalzemelerListesi.length > 0 ? (
                    filtrelenmisMalzemelerListesi.map((malzeme) => (
                      <li 
                        key={malzeme} 
                        onClick={() => {
                          setKullaniciAyarlari({
                            ...kullaniciAyarlari, 
                            sevilmeyenler: [...kullaniciAyarlari.sevilmeyenler, malzeme]
                          });
                          setMalzemeArama(""); 
                        }}
                      >
                        ➕ {malzeme}
                      </li>
                    ))
                  ) : (
                    <li style={{color:'#999', padding:'10px', cursor:'default'}}>Bulunamadı...</li>
                  )}
                </ul>
              )}
            </div>
          </div>
        </div>
        
        <button onClick={ayarlariKaydet} className="submit-btn full-width">
          Bilgileri Güncelle ✅
        </button>
      </div>

      {/* ========================================
          2. YORUMLARIM (YENİ EKLENEN)
          ======================================== */}
      <div style={{marginBottom:'40px', paddingBottom:'30px', borderBottom:'2px solid #eee'}}>
        <h2>💬 Yorumlarım</h2>
        <button 
          onClick={() => { setPanelAcik(true); setAktifPanelTab('profil'); }}
          style={{
            width: '100%', 
            padding: '15px', 
            backgroundColor: '#3498db',
            color: 'white', 
            border: 'none',
            borderRadius: '10px', 
            fontWeight: 'bold', 
            cursor: 'pointer',
            fontSize: '1rem',
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: '10px'
          }}
        >
          💬 Yorum Geçmişimi Görüntüle
        </button>
      </div>

      {/* ========================================
          3. ADMİN PANELİ (SADECE ADMİN GÖRÜR)
          ======================================== */}
      {adminListesi.includes(kullanici.email) && (
        <div style={{marginBottom:'40px', paddingBottom:'30px', borderBottom:'2px solid #eee'}}>
          <h2>🛡️ Admin Paneli</h2>
          
          {/* Yorum Yönetimi */}
          <button 
            onClick={() => { setPanelAcik(true); setAktifPanelTab('admin'); }}
            style={{
              width: '100%', 
              padding: '15px', 
              backgroundColor: '#c0392b',
              color: 'white', 
              border: 'none',
              borderRadius: '10px', 
              fontWeight: 'bold', 
              cursor: 'pointer',
              fontSize: '1rem',
              marginBottom: '10px'
            }}
          >
            🚩 Şikayetli Yorumları Görüntüle
          </button>

          {/* Tarif Ekleme */}
          <button 
            onClick={() => {
              setFormVerisi({ 
                ad: '', sure: '', zorluk: 'Kolay', maliyet: 'Ucuz', 
                kalori: '', protein: '', karbonhidrat: '', yag: '',
                kisiSayisi: '', resim: '', video: '', kategori: 'Ana Yemek',
                malzemelerStr: '', yapilisStr: '', ogunler: [], diyetler: [] 
              }); 
              setAktifDuzenlemeId(null); 
              setFormAcik(true);
            }}
            style={{
              width: '100%', 
              padding: '15px', 
              backgroundColor: '#27ae60',
              color: 'white', 
              border: 'none',
              borderRadius: '10px', 
              fontWeight: 'bold', 
              cursor: 'pointer',
              fontSize: '1rem',
              marginBottom: '10px'
            }}
          >
            ➕ Yeni Tarif Ekle
          </button>

          {/* Yedekleme */}
          <div style={{marginBottom:'20px', paddingBottom:'15px', borderBottom:'1px solid #eee'}}>
            <h4 style={{marginBottom:'10px'}}>📥 Veri Yönetimi</h4>
            <button 
              onClick={verileriIndir} 
              style={{
                width: '100%', 
                padding: '12px',
                backgroundColor: '#27ae60',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontWeight: 'bold',
                cursor: 'pointer',
                marginBottom: '10px'
              }}
            >
              📥 Tüm Verileri Bilgisayara İndir
            </button>
          </div>

          {/* Dosya Yükleme */}
          <div style={{marginBottom:'20px'}}>
            <h4 style={{marginBottom:'10px'}}>📂 Toplu JSON Yükle</h4>
            <input 
              type="file" 
              accept=".json" 
              onChange={dosyaYukle} 
              style={{
                border: '1px solid #ccc', 
                padding: '10px', 
                width: '100%', 
                background: '#f1f2f6', 
                borderRadius:'8px'
              }}
            />
          </div>

          {/* Tehlikeli Bölge */}
          <div style={{marginTop:'30px', paddingTop:'20px', borderTop:'2px dashed #ffcccc'}}>
            <h4 style={{color:'#c0392b', margin:'0 0 10px 0', fontSize:'1rem'}}>
              🚨 Tehlikeli Bölge
            </h4>
            <p style={{fontSize:'0.85rem', color:'#555', marginBottom:'15px'}}>
              Bu işlem geri alınamaz. Veritabanındaki bütün tarifleri kalıcı olarak siler.
            </p>
            
            <button 
              onClick={() => setAdminSilModali(true)} 
              style={{
                width: '100%', 
                padding: '12px', 
                backgroundColor: '#fff5f5', 
                color: '#c0392b',
                border: '1px solid #e74c3c', 
                borderRadius: '8px', 
                fontWeight: 'bold', 
                cursor: 'pointer'
              }}
            >
              💣 Tüm Yemekleri Sil
            </button>
          </div>
        </div>
      )}

      {/* ========================================
          4. HESAP SİLME (YENİ EKLENEN - HERKES İÇİN)
          ======================================== */}
      <div style={{marginBottom:'40px', paddingBottom:'30px', borderBottom:'2px solid #eee'}}>
        <h2>🗑️ Hesap Yönetimi</h2>
        {silmeAsamasi === 0 && (
          <button 
            onClick={() => setSilmeAsamasi(1)} 
            style={{
              width: '100%', 
              padding: '14px',
              backgroundColor: '#fff0f0', 
              color: '#d32f2f',
              border: 'none', 
              borderRadius: '12px', 
              fontWeight: 'bold',
              fontSize: '1rem',
              cursor: 'pointer'
            }}
          >
            🗑️ Hesabımı Sil
          </button>
        )}

        {silmeAsamasi === 1 && (
          <div style={{ backgroundColor: '#fff5f5', padding: '15px', borderRadius: '12px', textAlign: 'center', border: '1px solid #ffcdd2' }}>
            <h4 style={{margin: '0 0 10px 0', color: '#c62828'}}>Aramızdan ayrılıyor musun? 😔</h4>
            <p style={{fontSize: '13px', color: '#555', marginBottom: '15px'}}>
              Tariflerin ve tüm verilerin kalıcı olarak silinecek. Bu işlem geri alınamaz.
            </p>
            
            <div style={{display: 'flex', gap: '10px'}}>
              <button 
                onClick={() => setSilmeAsamasi(0)} 
                style={{
                  flex: 1,
                  padding: '10px', 
                  backgroundColor: 'white', 
                  color: '#333', 
                  border: '1px solid #ccc', 
                  borderRadius: '8px', 
                  cursor: 'pointer',
                  fontWeight: '600'
                }}
              >
                Vazgeç
              </button>
              <button 
                onClick={() => setSilmeAsamasi(2)} 
                style={{
                  flex: 1,
                  padding: '10px', 
                  backgroundColor: '#d32f2f', 
                  color: 'white', 
                  border: 'none', 
                  borderRadius: '8px', 
                  cursor: 'pointer',
                  fontWeight: '600'
                }}
              >
                Evet, Devam Et
              </button>
            </div>
          </div>
        )}

        {silmeAsamasi === 2 && (
          <div style={{ backgroundColor: '#e3f2fd', padding: '15px', borderRadius: '12px', textAlign: 'center', border: '1px solid #90caf9' }}>
            <h4 style={{margin: '0 0 10px 0', color: '#1565c0'}}>🔒 Güvenlik Kontrolü</h4>
            
            <p style={{fontSize: '13px', color: '#333', marginBottom: '15px', lineHeight:'1.5'}}>
              Güvenliğiniz için Google penceresi açılacak.<br/>
              Lütfen açılan ekranda şu hesabı seçtiğinden emin ol:<br/>
              <strong style={{background:'white', padding:'4px 10px', borderRadius:'4px', marginTop:'8px', display:'inline-block', color:'#d32f2f', border:'1px dashed #d32f2f'}}>
                {kullanici?.email}
              </strong>
            </p>

            {silmeHataMesaji && (
              <div style={{color: '#d32f2f', fontWeight: 'bold', fontSize: '0.9rem', marginBottom: '15px', background: '#ffcdd2', padding: '10px', borderRadius: '6px'}}>
                {silmeHataMesaji}
              </div>
            )}

            <div style={{display: 'flex', gap: '10px'}}>
              <button 
                onClick={() => {setSilmeAsamasi(0); setSilmeHataMesaji("");}} 
                style={{
                  flex: 1, 
                  padding: '12px', 
                  backgroundColor: 'white', 
                  color: '#333', 
                  border: '1px solid #ccc', 
                  borderRadius: '8px', 
                  cursor: 'pointer',
                  fontWeight: '600'
                }}
              >
                İptal
              </button>
              
              <button 
                onClick={hesabiSil}
                style={{
                  flex: 1,
                  padding: '12px', 
                  backgroundColor: '#1565c0',
                  color: 'white', 
                  border: 'none', 
                  borderRadius: '8px', 
                  fontWeight: 'bold', 
                  cursor: 'pointer'
                }}
              >
                Doğrula ve Sil 🗑️
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ========================================
          5. ÇIKIŞ YAP BUTONU (EN ALTTA)
          ======================================== */}
      <button 
        onClick={cikisYap}
        style={{
          width: '100%',
          padding: '15px',
          background: '#e74c3c',
          color: 'white',
          border: 'none',
          borderRadius: '10px',
          cursor: 'pointer',
          fontWeight: 'bold',
          fontSize: '1rem'
        }}
      >
        🚪 Çıkış Yap
      </button>
    </div>
  ) : (
    <div style={{textAlign:'center', padding:'80px 20px'}}>
      <p style={{fontSize:'3rem'}}>🔐</p>
      <h2>Hoş Geldin!</h2>
      <p style={{marginBottom:'30px', color:'#666'}}>
        Profilini oluşturmak ve ayarları kullanmak için giriş yap
      </p>
      <button onClick={girisYap} className="login-btn">
        Google ile Giriş Yap
      </button>
    </div>
  )
)}
{/* 🏠 SADECE ELİNDEKİLER MODU (SIKI) */}


{/* DETAY MODAL (YORUM SİLME ÖZELLİĞİ VE ADMİN YETKİSİ EKLENDİ) */}
      {secilenYemek && (
        <div className="modal-overlay" onClick={() => { setSecilenYemek(null); setKullaniciOyu(0); }}>
          <div 
            className="modal-content" 
            onClick={e => e.stopPropagation()} 
            style={{
                padding: 0, borderRadius: '15px', maxHeight: '90vh', overflowY: 'auto',     
                display: 'flex', flexDirection: 'column', position: 'relative', backgroundColor: 'white'
            }}
          >
            
            {/* 1. MEDYA VE KAPAT BUTONU */}
            <div style={{position:'relative', backgroundColor:'#000', flexShrink: 0}}>
               <button 
                  onClick={() => { setSecilenYemek(null); setKullaniciOyu(0); }}
                  style={{
                    position: 'absolute', top: '15px', right: '15px', zIndex: 20,
                    width: '36px', height: '36px', borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.95)', color: '#e74c3c', border: 'none', 
                    fontSize: '1.2rem', fontWeight:'bold', boxShadow: '0 2px 10px rgba(0,0,0,0.2)', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}
                  className="action-btn"
               >✕</button>

               {getYoutubeId(secilenYemek.video) ? (
                  <div className="video-container" style={{margin:0, borderRadius:0}}>
                    <iframe src={`https://www.youtube.com/embed/${getYoutubeId(secilenYemek.video)}`} title="Video" allowFullScreen style={{border:'none', display:'block', width:'100%', minHeight:'250px'}}></iframe>
                  </div>
                ) : (
                <img 
  src={secilenYemek.resim || "https://dummyimage.com/400x300/e0e0e0/666666&text=Resim+Hazirlaniyor"} 
  alt={secilenYemek.ad || "Yemek"} 
  style={{width:'100%', maxHeight:'350px', objectFit:'cover', display:'block'}} 
  onError={(e) => { 
    e.target.onerror = null; 
    e.target.src = "https://dummyimage.com/400x300/e0e0e0/666666&text=Resim+Bulunamadi"; 
  }} 
/>
                )}
            </div>

            <div style={{padding:'20px'}}>
              
             {/* 2. BAŞLIK VE KONTROL PANELİ (CANLI VERİ ENTEGRELİ) */}
<div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'15px'}}>
    <div style={{maxWidth:'65%'}}>
        <h2 style={{margin:0, fontSize:'1.5rem', color:'#2c3e50', lineHeight:'1.2'}}>{secilenYemek.ad}</h2>
        
        {/* ⭐ CANLI PUAN HESAPLAMA */}
        <div style={{
            marginTop:'6px', display:'inline-flex', alignItems:'center', gap:'4px',
            backgroundColor:'#fff9c4', color:'#f1c40f', padding:'4px 8px', 
            borderRadius:'12px', fontWeight:'bold', fontSize:'0.9rem'
        }}>
            <span>★</span>
            <span>
                {aktifYemekYorumlari.length > 0 
                  ? (aktifYemekYorumlari.reduce((acc, curr) => acc + (Number(curr.rating) || 0), 0) / aktifYemekYorumlari.length).toFixed(1) 
                  : "0.0"}
            </span>
        </div>
    </div>

    <div style={{display:'flex', flexDirection:'column', alignItems:'flex-end', gap:'8px'}}>
        {kullanici && (adminListesi.includes(kullanici.email) || secilenYemek.ekleyen === kullanici.email) && (
          <div style={{display:'flex', gap:'5px'}}>
            <button onClick={() => duzenlemeyiBaslat(secilenYemek)} className="edit-icon-btn">✏️</button>
            <button onClick={() => yemekSil(secilenYemek.id)} className="delete-icon-btn">🗑️</button>
          </div>
        )}

        <div style={{display:'flex', gap:'6px'}}>
            <button 
              className="action-btn"
              onClick={() => setYorumModalAcik(true)}
              style={{
                  padding:'6px 10px', backgroundColor:'#f0f2f5', color:'#2c3e50', 
                  border:'1px solid #dcdcdc', borderRadius:'8px', cursor:'pointer', 
                  fontWeight:'600', fontSize:'0.9rem', display:'flex', alignItems:'center', gap:'4px'
              }}
            >
              <span>💬</span>
              {/* 💬 CANLI YORUM SAYISI */}
              <span>{aktifYemekYorumlari.length}</span>
            </button>

            <button 
              className="action-btn"
              onClick={() => paylas(secilenYemek)} 
  style={{
      padding:'6px 10px', backgroundColor:'#f0f2f5', color:'#2c3e50', 
      border:'1px solid #dcdcdc', borderRadius:'8px', cursor:'pointer', fontSize:'1rem'
  }}
>
  📲
</button>


        </div>
    </div>
</div>

              {/* Rozetler */}
<div style={{ display: 'flex', gap: '8px', marginBottom: '20px' }}>
  
  {/* ZORLUK ROZETİ: Zorluğa göre renk değiştirir */}
  <span style={{
    padding: '6px 12px', 
    borderRadius: '8px', 
    fontSize: '0.85rem', 
    fontWeight: 'bold',
    background: 
      secilenYemek.zorluk === 'Kolay' ? '#e8f5e9' : 
      secilenYemek.zorluk === 'Zor' ? '#ffebee' : '#fff3e0',
    color: 
      secilenYemek.zorluk === 'Kolay' ? '#2e7d32' : 
      secilenYemek.zorluk === 'Zor' ? '#c62828' : '#ef6c00',
    border: `1px solid ${
      secilenYemek.zorluk === 'Kolay' ? '#c8e6c9' : 
      secilenYemek.zorluk === 'Zor' ? '#ffcdd2' : '#ffe0b2'
    }`
  }}>
    Yapımı {secilenYemek.zorluk || 'Orta'}
  </span>
                  {/* MALİYET ROZETİ: Maliyete göre renk değiştirir */}
  <span style={{
    padding: '6px 12px', 
    borderRadius: '8px', 
    fontSize: '0.85rem', 
    fontWeight: 'bold',
    background: 
      secilenYemek.maliyet === 'Pahalı' ? '#f3e5f5' : // Pahalı için hafif mor (lüks hissi)
      secilenYemek.maliyet === 'Ucuz' ? '#e3f2fd' : '#f5f5f5', // Ucuz için mavi, orta için gri
    color: 
      secilenYemek.maliyet === 'Pahalı' ? '#7b1fa2' : 
      secilenYemek.maliyet === 'Ucuz' ? '#1976d2' : '#616161',
    border: `1px solid ${
      secilenYemek.maliyet === 'Pahalı' ? '#e1bee7' : 
      secilenYemek.maliyet === 'Ucuz' ? '#bbdefb' : '#e0e0e0'
    }`
  }}>
    {/* Maliyet İkonları */}
    <span style={{ marginRight: '4px' }}>
      {secilenYemek.maliyet === 'Pahalı' ? '₺₺₺' : (secilenYemek.maliyet === 'Orta' ? '₺₺' : '₺')}
    </span>
    {secilenYemek.maliyet}
  </span>

</div>

              {/* Besin Değerleri */}
              <div className="smart-nutrition-box">
                <div className="smart-header">
                  <span className="smart-title">Besin Değerleri</span>
                  <div className="smart-controls">
                      <button className="mini-btn" onClick={() => setSecilenPorsiyon(p => p > 1 ? p - 1 : 1)}>-</button>
                      <span className="smart-count">{secilenPorsiyon} Kişilik</span>
                      <button className="mini-btn" onClick={() => setSecilenPorsiyon(p => p + 1)}>+</button>
                  </div>
                </div>
                <div className="smart-values">
                    <div className="smart-item"><span className="smart-val">{Math.round((secilenYemek.kalori / (secilenYemek.kisiSayisi || 1)) * secilenPorsiyon)}</span><span className="smart-label">Kalori</span></div>
                    <div className="smart-item"><span className="smart-val">{Math.round(((secilenYemek.protein || 0) / (secilenYemek.kisiSayisi || 1)) * secilenPorsiyon)}g</span><span className="smart-label">Protein</span></div>
                    <div className="smart-item"><span className="smart-val">{Math.round(((secilenYemek.karbonhidrat || 0) / (secilenYemek.kisiSayisi || 1)) * secilenPorsiyon)}g</span><span className="smart-label">Karb.</span></div>
                    <div className="smart-item"><span className="smart-val">{Math.round(((secilenYemek.yag || 0) / (secilenYemek.kisiSayisi || 1)) * secilenPorsiyon)}g</span><span className="smart-label">Yağ</span></div>
                </div>
              </div>

              <h4>Malzemeler <small style={{fontWeight:'normal', color:'#666'}}>({secilenYemek.kisiSayisi} kişilik)</small></h4>
              <ul className="malzeme-listesi">
                {Object.entries(secilenYemek.malzemeler || {}).map(([malzeme, miktar]) => {
                   let yeniMiktar = miktar;
                   const sayi = parseFloat(miktar);
                   if (!isNaN(sayi)) {
                      const oran = secilenPorsiyon / (Number(secilenYemek.kisiSayisi) || 1);
                      const birim = miktar.replace(sayi, '').trim();
                      yeniMiktar = `${(sayi * oran).toFixed(1).replace('.0','')} ${birim}`;
                   }
                   return <li key={malzeme}><b>{yeniMiktar}</b> {malzeme}</li>
                })}
              </ul>

              <h4>Yapılışı</h4>
              <ol className="yapilis-listesi">
                {(secilenYemek.yapilisAdimlari || []).map((adim, i) => <li key={i}>{adim}</li>)}
              </ol>
{/* --- CANLI YORUM LİSTESİ --- */}
          <div style={{marginTop:'30px', borderTop:'1px solid #eee', paddingTop:'20px'}}>
             <h3 style={{fontSize:'1.3rem', marginBottom:'15px', color:'#2c3e50'}}>
               Yorumlar ({aktifYemekYorumlari.length})
             </h3>

             {/* KULLANICININ BU YEMEĞE YORUM YAPIP YAPMADIĞINI KONTROL ET */}
             {kullanici && !aktifYemekYorumlari.find(y => y.userId === kullanici.uid) && (
                <button 
                  onClick={() => setYorumModalAcik(true)}
                  style={{
                    width: '100%', padding: '12px', marginBottom: '20px',
                    backgroundColor: '#e67e22', color: 'white', border: 'none',
                    borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                  }}
                >
                  ✍️ Bu Tarife Yorum Yap
                </button>
             )}

             {/* KENDİ YORUMUN VARSA BİLGİ VER */}
             {kullanici && aktifYemekYorumlari.find(y => y.userId === kullanici.uid) && (
                <div style={{padding:'10px', backgroundColor:'#e8f8f5', color:'#27ae60', borderRadius:'8px', marginBottom:'15px', textAlign:'center', border:'1px solid #a9dfbf'}}>
                   ✅ Bu tarife zaten yorum yaptın.
                </div>
             )}

             {/* LİSTELEME */}
             {aktifYemekYorumlari.length === 0 ? (
               <div style={{textAlign:'center', color:'#999', padding:'20px', background:'#f9f9f9', borderRadius:'10px'}}>
                 <p>Henüz yorum yapılmamış.</p>
               </div>
             ) : (
               <div className="comments-list">
                 {aktifYemekYorumlari.map((yorum) => (
                   <div key={yorum.id} style={{
                     backgroundColor: (kullanici && yorum.userId === kullanici.uid) ? '#fef9e7' : '#f8f9fa', // Senin yorumunsa sarımtırak
                     padding: '15px', 
                     marginBottom: '10px',
                     borderRadius: '10px',
                     borderLeft: (kullanici && yorum.userId === kullanici.uid) ? '4px solid #f1c40f' : '4px solid #ddd',
                     position: 'relative'
                   }}>
                     <div style={{display:'flex', justifyContent:'space-between', marginBottom:'4px'}}>
                       <strong style={{color: (kullanici && yorum.userId === kullanici.uid) ? '#d35400' : '#2c3e50'}}>
                          {yorum.userName || "Misafir"} {(kullanici && yorum.userId === kullanici.uid) ? "(Sen)" : ""}
                       </strong>
                       <span style={{fontSize:'0.8rem', color:'#888'}}>
                         {yorum.createdAt?.seconds ? new Date(yorum.createdAt.seconds * 1000).toLocaleDateString('tr-TR') : ''}
                       </span>
                     </div>
                     
                     <div style={{color:'#f1c40f', fontSize:'0.9rem', marginBottom:'5px'}}>
                        {"⭐".repeat(yorum.rating)}
                     </div>

                     <p style={{margin:0, color:'#555', fontSize:'0.95rem', lineHeight:'1.4'}}>{yorum.text}</p>

                     {/* SİLME BUTONU: Sadece kendi yorumunsa veya adminsen */}
                     {kullanici && (adminListesi.includes(kullanici.email) || kullanici.uid === yorum.userId) && (
                        <button 
                          onClick={(e) => {
                            e.stopPropagation(); 
                            yorumSil(yorum.id); 
                          }}
                          style={{
                            position: 'absolute', bottom: '10px', right: '10px',
                            background: '#fff', border: '1px solid #e74c3c', color: '#e74c3c',
                            cursor: 'pointer', fontSize: '0.8rem', padding:'3px 8px', borderRadius:'4px'
                          }}
                        >
                          Sil
                        </button>
                     )}
                   </div>
                 ))}
               </div>
             )}
          </div>
          {/* 👆👆 YAPIŞTIRMA BURADA BİTECEK 👆👆 */}
            </div>
          </div>

          {/* 👇 POP-UP: YORUM VE PUANLAMA */}
          {yorumModalAcik && (
             <div style={{
                 position:'absolute', top:0, left:0, width:'100%', height:'100%', 
                 backgroundColor:'rgba(0,0,0,0.6)', zIndex: 100,
                 display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(3px)'
             }} onClick={(e) => { e.stopPropagation(); setYorumModalAcik(false); }}>
                 
                 <div style={{backgroundColor:'white', width:'85%', maxHeight:'70%', borderRadius:'15px', padding:'25px', overflowY:'auto', boxShadow:'0 10px 25px rgba(0,0,0,0.3)', position:'relative'}} onClick={e=>e.stopPropagation()}>
                    
                    <div style={{display:'flex', justifyContent:'space-between', marginBottom:'20px', borderBottom:'1px solid #eee', paddingBottom:'10px'}}>
                       <h3 style={{margin:0, color:'#2c3e50'}}>💬 Değerlendirmeler</h3>
                       <button onClick={()=>setYorumModalAcik(false)} style={{background:'none', border:'none', fontSize:'1.5rem', cursor:'pointer', color:'#e74c3c'}}>✕</button>
                    </div>
                    
                    {/* A) KULLANICI GİRİŞ YAPMIŞSA VE ZATEN YORUM YAPMIŞSA (GÜNCEL) */}
{kullanici && aktifYemekYorumlari.find(y => y.userId === kullanici.uid) ? (
    (() => {
        const benimYorumum = aktifYemekYorumlari.find(y => y.userId === kullanici.uid);
        return (
            <div style={{marginBottom:'25px', backgroundColor:'#f0f8ff', padding:'15px', borderRadius:'10px', border:'1px solid #d6eaf8'}}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'10px'}}>
                    <h4 style={{margin:0, color:'#2980b9'}}>Senin Değerlendirmen</h4>
                    {/* 👇 Burada senin yorumSil fonksiyonunu kullanıyoruz */}
                    <button 
                        onClick={() => yorumSil(benimYorumum.id)}
                        style={{background:'#e74c3c', color:'white', border:'none', padding:'5px 10px', borderRadius:'5px', cursor:'pointer', fontSize:'0.8rem'}}
                    >
                        🗑️ Sil & Yeniden Yaz
                    </button>
                </div>
                <div style={{display:'flex', alignItems:'center', gap:'5px', marginBottom:'5px'}}>
                    <span style={{color:'#f1c40f', fontSize:'1.2rem'}}>
                        {'★'.repeat(benimYorumum.rating || 0)}
                        {'☆'.repeat(5 - (benimYorumum.rating || 0))}
                    </span>
                    <span style={{fontWeight:'bold'}}>{benimYorumum.rating}/5</span>
                </div>
                <p style={{margin:'0', color:'#555', fontStyle:'italic'}}>"{benimYorumum.text}"</p>
            </div>
        );
    })()
) : (
    /* B) YORUM YAPMAMIŞSA FORM GÖSTER */
    <div style={{marginBottom:'25px', backgroundColor:'#f9f9f9', padding:'15px', borderRadius:'10px'}}>
        <h4 style={{marginTop:0, fontSize:'0.95rem', color:'#555'}}>Puan Ver & Yorum Yaz:</h4>
        <div 
            className={puanHata ? 'shake-animation' : ''} 
            style={{ display: 'flex', gap: '5px', marginBottom: '10px', cursor: 'pointer' }}
        >
            {[1, 2, 3, 4, 5].map(s => (
                <span 
                    key={s} 
                    style={{ fontSize: '1.8rem', color: s <= kullaniciOyu ? '#f1c40f' : '#ddd', transition: '0.2s' }} 
                    onClick={() => {
                        setKullaniciOyu(s);
                        setPuanHata(false);
                    }}
                >
                    ★
                </span>
            ))}
        </div>
        <textarea 
            placeholder="Düşüncelerini paylaş..." 
            value={yorumMetni}
            onChange={(e) => setYorumMetni(e.target.value)}
            rows="3"
            style={{width:'100%', padding:'10px', borderRadius:'8px', border:'1px solid #ddd', marginBottom:'10px', fontFamily:'inherit', resize:'none'}}
        />
        <button onClick={yorumGonder} style={{width:'100%', background:'#27ae60', color:'white', border:'none', padding:'10px', borderRadius:'8px', cursor:'pointer', fontWeight:'bold'}}>
            Gönder 🚀
        </button>
    </div>
)}

                  {/* C) TÜM YORUMLAR LİSTESİ (GÜNCEL VERSİYON) */}
                  <h4 style={{color:'#2c3e50', borderBottom:'1px solid #eee', paddingBottom:'5px'}}>
                    Yorumlar ({aktifYemekYorumlari.length})
                  </h4>

                  {aktifYemekYorumlari.length === 0 ? (
                      <div style={{textAlign:'center', padding:'20px', color:'#95a5a6'}}>
                          <p>Henüz yorum yok. İlk yorumu sen yap! 🚀</p>
                      </div>
                  ) : (
                      <div style={{display:'flex', flexDirection:'column', gap:'15px'}}>
                          {/* 🔥 YENİ SİSTEM: aktifYemekYorumlari kullanıyoruz */}
                          {aktifYemekYorumlari.map((y) => (
                              <div key={y.id} style={{ borderBottom: '1px solid #eee', padding: '15px 0', position: 'relative' }}>
                              
                                {/* ÜST KISIM: Kullanıcı Bilgisi */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                  <div>
                                    <div style={{ fontWeight: 'bold', color: '#34495e', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      {/* 👇 Veritabanı alanı: userName */}
                                      👤 {y.userName || "Misafir"}
                                      
                                      {/* 👇 Veritabanı alanı: createdAt */}
                                      <small style={{ color: '#bdc3c7', fontWeight: 'normal', fontSize: '0.7rem' }}>
                                          • {y.createdAt?.seconds ? new Date(y.createdAt.seconds * 1000).toLocaleDateString('tr-TR') : 'Az önce'}
                                      </small>
                                    </div>

                                    {/* 👇 Veritabanı alanı: rating */}
                                    <div style={{ color: '#f1c40f', fontSize: '0.8rem', marginTop: '2px' }}>
                                      {'★'.repeat(y.rating || 0)}{'☆'.repeat(5 - (y.rating || 0))}
                                    </div>
                                  </div>

                                  {/* ÜÇ NOKTA MENÜSÜ (Silme/Bildirme) */}
                                  <div style={{ position: 'relative' }}>
                                    <button 
                                      onClick={() => setAcikMenuId(acikMenuId === y.id ? null : y.id)}
                                      style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.2rem', color: '#95a5a6', padding: '0 5px' }}
                                    >
                                      ⋮
                                    </button>

                                    {acikMenuId === y.id && (
                                      <div style={{ 
                                        position: 'absolute', right: 0, top: '25px', backgroundColor: 'white', 
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)', borderRadius: '8px', zIndex: 100, 
                                        minWidth: '140px', border: '1px solid #eee', overflow: 'hidden' 
                                      }}>
                                          
                                          {/* SİLME BUTONU: Sadece kendi yorumuysa veya Adminse görünür */}
                                          {kullanici && (kullanici.uid === y.userId || adminListesi.includes(kullanici.email)) && (
                                            <button 
                                              onClick={() => { yorumSil(y.id); setAcikMenuId(null); }}
                                              style={{ 
                                                width: '100%', padding: '12px', textAlign: 'left', background: 'none', 
                                                border: 'none', cursor: 'pointer', color: '#e74c3c', fontSize: '0.85rem' 
                                              }}
                                            >
                                              🗑️ Sil
                                            </button>
                                          )}

                                          {/* BİLDİR BUTONU: Başkasının yorumuysa */}
{kullanici && kullanici.uid !== y.userId && (
    <button 
      onClick={() => { 
        console.log("Bildirilecek Yorum:", y); 
        yorumBildir(y); 
        setAcikMenuId(null); 
      }} 
      style={{ 
        width: '100%', padding: '12px', textAlign: 'left', background: 'none', 
        border: 'none', cursor: 'pointer', fontSize: '0.85rem', color: '#666' 
      }}
    >
        🚩 Bildir
    </button>
)}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* 👇 Veritabanı alanı: text */}
                                <p style={{ marginTop: '5px', color: '#555', fontSize: '0.95rem' }}>
                                    {y.text}
                                </p>

                              </div>
                          ))}
                      </div>
                  )}
                  </div>
              </div>
          )}
        </div>
      )}
      {/* ⚙️ YENİ PROFİL VE SAĞLIK AYARLARI */}
      {profilAcik && (
        <div className="modal-overlay">
          <div className="modal-content settings-modal">
            <button className="close-btn" onClick={() => setProfilAcik(false)}>×</button>
            <h2>👤 Profil & Hedefler</h2>
            {/* --- 1. YENİ EKLENEN BUTON (En Tepeye) --- */}
            <div style={{marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #eee'}}>
              <button 
                onClick={() => { setProfilAcik(false); setPanelAcik(true); }}
                style={{
                  width: '100%', 
                  padding: '12px', 
                  backgroundColor: '#3498db', // Mavi renk (Bilgi/Navigasyon rengi)
                  color: 'white', 
                  border: 'none',
                  borderRadius: '10px', 
                  fontWeight: 'bold', 
                  cursor: 'pointer',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
                  boxShadow: '0 4px 10px rgba(52, 152, 219, 0.2)',
                  transition: 'transform 0.1s'
                }}
              >
                {/* Admin ise farklı, kullanıcı ise farklı ikon/yazı */}
                <span style={{fontSize: '1.2rem'}}>
                  {adminListesi.includes(kullanici?.email) ? '🛡️' : '💬'}
                </span>
                {adminListesi.includes(kullanici?.email) ? 'Yorumlar & Admin Paneli' : 'Yorum Geçmişim'}
                <span style={{marginLeft: 'auto', opacity: 0.7}}>❯</span>
              </button>
            </div>
            
            <div className="settings-section">
              <h3>1. Kişisel Bilgiler</h3>
              <div className="form-group"><label>Profil Resmi (URL)</label><input type="text" placeholder="Örn: https://resim.com/ben.jpg" value={kullaniciAyarlari.ozelResim} onChange={(e) => setKullaniciAyarlari({...kullaniciAyarlari, ozelResim: e.target.value})} /><small>Boş bırakırsan Google resmin görünür.</small></div>
             <div style={{display:'flex', gap:'8px'}}>
  <div style={{flex:1}}>
    <label style={{fontSize:'0.75rem', color:'#666', display:'block', marginBottom:'4px'}}>Yaş</label>
    <input type="number" value={kullaniciAyarlari.yas} onChange={(e)=>setKullaniciAyarlari({...kullaniciAyarlari, yas:e.target.value})}
      style={{width:'100%', padding:'8px 6px', borderRadius:'8px', border:'1px solid #ddd', fontSize:'0.9rem'}}/>
  </div>
  <div style={{flex:1}}>
    <label style={{fontSize:'0.75rem', color:'#666', display:'block', marginBottom:'4px'}}>Boy (cm)</label>
    <input type="number" value={kullaniciAyarlari.boy} onChange={(e)=>setKullaniciAyarlari({...kullaniciAyarlari, boy:e.target.value})}
      style={{width:'100%', padding:'8px 6px', borderRadius:'8px', border:'1px solid #ddd', fontSize:'0.9rem'}}/>
  </div>
  <div style={{flex:1}}>
    <label style={{fontSize:'0.75rem', color:'#666', display:'block', marginBottom:'4px'}}>Kilo (kg)</label>
    <input type="number" value={kullaniciAyarlari.kilo} onChange={(e)=>setKullaniciAyarlari({...kullaniciAyarlari, kilo:e.target.value})}
      style={{width:'100%', padding:'8px 6px', borderRadius:'8px', border:'1px solid #ddd', fontSize:'0.9rem'}}/>
  </div>
</div>
              <div className="form-group"><label>Cinsiyet</label><select value={kullaniciAyarlari.cinsiyet} onChange={(e)=>setKullaniciAyarlari({...kullaniciAyarlari, cinsiyet:e.target.value})}><option>Erkek</option><option>Kadın</option></select></div>
              
              <div className="form-group">
                <label>🎯 Hedefin Ne?</label>
                <select value={kullaniciAyarlari.hedef} onChange={(e)=>setKullaniciAyarlari({...kullaniciAyarlari, hedef:e.target.value})}>
                  <option value="Koru">Kilomu Koru</option>
                  <option value="Ver">Kilo Ver (-500 kcal)</option>
                  <option value="Al">Kilo Al (+500 kcal)</option>
                </select>
              </div>

              {saglikSonuc && (
                <div className="health-card">
                   <p>📊 VKİ: <b>{saglikSonuc.vki}</b> ({saglikSonuc.vkiDurumu})</p>
                   <p>🔥 Günlük Hedef: <b>{saglikSonuc.gunlukKalori} kcal</b></p>
                </div>
              )}
            </div>
            
            

            <div className="settings-section">
              <h3>2. Tercihler</h3>
             {/* GECE MODU AYARI - ANINDA KAYIT */}
<div className="form-group">
  <label style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
    <span>🌙 Gece Modu</span>
    <div 
      onClick={() => {
        const yeniDeger = !geceModu;
        setGeceModu(yeniDeger);
        localStorage.setItem('geceModu', String(yeniDeger));  // ✅ Anında kaydet
      }}
      style={{
        width: '50px', height: '26px', borderRadius: '15px', position: 'relative',
        cursor: 'pointer', transition: '0.3s',
        backgroundColor: geceModu ? '#2c3e50' : '#cbd5e0'
      }}
    >
      <div style={{
        width: '20px', height: '20px', backgroundColor: 'white', borderRadius: '50%',
        position: 'absolute', top: '3px', transition: '0.3s',
        left: geceModu ? '27px' : '3px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
      }} />
    </div>
  </label>
  <small>Göz yorgunluğunu azaltmak için karanlık tema</small>
</div>

              {/* Diyet Seçimi */}
              <div className="form-group">
                <label>Özel Diyet</label>
                <select value={kullaniciAyarlari.diyet} onChange={(e) => setKullaniciAyarlari({...kullaniciAyarlari, diyet: e.target.value})}>
                  <option value="Yok">Yok</option>
                  {diyetSecenekleri.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
              </div>
              
              {/* Modern Malzeme Seçici */}
              <div className="form-group">
                <label>🚫 Sevmediğim Malzemeler</label>
                
                <div className="combobox-container">
                  {/* 1. SEÇİLENLER (Kırmızı Etiketler) */}
                  <div className="selected-tags">
                    {kullaniciAyarlari.sevilmeyenler.length === 0 && <span style={{fontSize:'0.8rem', color:'#999'}}>Henüz seçim yapmadınız.</span>}
                    {kullaniciAyarlari.sevilmeyenler.map((malzeme) => (
                      <span key={malzeme} className="tag-chip" onClick={() => {
                          const yeniListe = kullaniciAyarlari.sevilmeyenler.filter(i => i !== malzeme);
                          setKullaniciAyarlari({...kullaniciAyarlari, sevilmeyenler: yeniListe});
                      }}>
                        {malzeme} ✖
                      </span>
                    ))}
                  </div>

                  {/* 2. ARAMA KUTUSU */}
                  <input 
                    type="text" 
                    placeholder="Malzeme ara... (Örn: Soğan)" 
                    value={malzemeArama}
                    onChange={(e) => setMalzemeArama(e.target.value)}
                    className="modal-input search-input"
                  />

                  {/* 3. AÇILIR LİSTE */}
                  {malzemeArama && (
                    <ul className="dropdown-list">
                      {filtrelenmisMalzemelerListesi.length > 0 ? (
                        filtrelenmisMalzemelerListesi.map((malzeme) => (
                          <li key={malzeme} onClick={() => {
                            setKullaniciAyarlari({...kullaniciAyarlari, sevilmeyenler: [...kullaniciAyarlari.sevilmeyenler, malzeme]});
                            setMalzemeArama(""); 
                          }}>
                            ➕ {malzeme}
                          </li>
                        ))
                      ) : (
                        <li style={{color:'#999', padding:'10px', cursor:'default'}}>Bulunamadı...</li>
                      )}
                    </ul>
                  )}
                </div>
              </div>
            </div>
               
            <button onClick={ayarlariKaydet} className="submit-btn full-width">Bilgileri Güncelle ✅</button>

         
{/* --- PROFESYONEL HESAP SİLME ALANI (GÜNCELLENMİŞ VERSİYON) --- */}
<div style={{ marginTop: '30px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
  
  {/* AŞAMA 0: Sadece İlk Buton Görünür */}
  {silmeAsamasi === 0 && (
    <button 
      onClick={() => setSilmeAsamasi(1)} 
      style={{
        width: '100%', 
        padding: '14px',
        backgroundColor: '#fff0f0', 
        color: '#d32f2f',
        border: 'none', 
        borderRadius: '12px', 
        fontWeight: 'bold',
        fontSize: '1rem',
        cursor: 'pointer', 
        transition: '0.2s'
      }}
    >
      🗑️ Hesabımı Sil
    </button>
  )}

  {/* AŞAMA 1: İlk Onay (Emin misin?) */}
  {silmeAsamasi === 1 && (
    <div style={{ backgroundColor: '#fff5f5', padding: '15px', borderRadius: '12px', textAlign: 'center', border: '1px solid #ffcdd2' }}>
      <h4 style={{margin: '0 0 10px 0', color: '#c62828'}}>Aramızdan ayrılıyor musun? 😔</h4>
      <p style={{fontSize: '13px', color: '#555', marginBottom: '15px'}}>
        Tariflerin ve tüm verilerin kalıcı olarak silinecek. Bu işlem geri alınamaz.
      </p>
      
      {/* BUTONLAR BURADA DÜZELTİLDİ */}
      <div style={{display: 'flex', gap: '10px'}}>
        <button 
          onClick={() => setSilmeAsamasi(0)} 
          style={{
            flex: 1, // Kutuya yayıl
            padding: '10px', 
            backgroundColor: 'white', 
            color: '#333', 
            border: '1px solid #ccc', 
            borderRadius: '8px', 
            cursor: 'pointer',
            fontWeight: '600'
          }}
        >
          Vazgeç
        </button>
        <button 
          onClick={() => setSilmeAsamasi(2)} 
          style={{
            flex: 1, // Kutuya yayıl
            padding: '10px', 
            backgroundColor: '#d32f2f', 
            color: 'white', 
            border: 'none', 
            borderRadius: '8px', 
            cursor: 'pointer',
            fontWeight: '600'
          }}
        >
          Evet, Devam Et
        </button>
      </div>
    </div>
  )}

  {/* AŞAMA 2: Güvenlik Uyarısı ve Son Adım */}
  {silmeAsamasi === 2 && (
    <div style={{ backgroundColor: '#e3f2fd', padding: '15px', borderRadius: '12px', textAlign: 'center', border: '1px solid #90caf9' }}>
      <h4 style={{margin: '0 0 10px 0', color: '#1565c0'}}>🔒 Güvenlik Kontrolü</h4>
      
      <p style={{fontSize: '13px', color: '#333', marginBottom: '15px', lineHeight:'1.5'}}>
        Güvenliğiniz için Google penceresi açılacak.<br/>
        Lütfen açılan ekranda şu hesabı seçtiğinden emin ol:<br/>
        <strong style={{background:'white', padding:'4px 10px', borderRadius:'4px', marginTop:'8px', display:'inline-block', color:'#d32f2f', border:'1px dashed #d32f2f'}}>
          {kullanici?.email}
        </strong>
      </p>

      {/* Hata Mesajı Alanı */}
      {silmeHataMesaji && (
        <div style={{color: '#d32f2f', fontWeight: 'bold', fontSize: '0.9rem', marginBottom: '15px', background: '#ffcdd2', padding: '10px', borderRadius: '6px'}}>
          {silmeHataMesaji}
        </div>
      )}

      {/* BUTONLAR BURADA DÜZELTİLDİ */}
      <div style={{display: 'flex', gap: '10px'}}>
        <button 
          onClick={() => {setSilmeAsamasi(0); setSilmeHataMesaji("");}} 
          style={{
            flex: 1, 
            padding: '12px', 
            backgroundColor: 'white', 
            color: '#333', 
            border: '1px solid #ccc', 
            borderRadius: '8px', 
            cursor: 'pointer',
            fontWeight: '600'
          }}
        >
          İptal
        </button>
        
        <button 
          onClick={hesabiSil}
          style={{
            flex: 1,
            padding: '12px', 
            backgroundColor: '#1565c0', // Mavi (Onay rengi)
            color: 'white', 
            border: 'none', 
            borderRadius: '8px', 
            fontWeight: 'bold', 
            cursor: 'pointer'
          }}
        >
          Doğrula ve Sil 🗑️
        </button>
      </div>
    </div>
  )}

</div>

{/* --- PROFESYONEL HESAP SİLME ALANI (BİTİŞ) --- */}

          {/* 👇 SADECE ADMİN İÇİN DOSYA YÜKLEME VE YEDEKLEME ALANI 👇 */}
            {adminListesi.includes(kullanici?.email) && (
              <div style={{marginTop: '30px', borderTop: '2px dashed #ccc', paddingTop: '20px'}}>
                <h3 style={{color:'#d63031'}}>⚡ Admin Paneli</h3>
                
                {/* 👇 1. YEDEK ALMA BÖLÜMÜ (YENİ EKLENEN KISIM) 👇 */}
                <div style={{marginBottom: '20px', paddingBottom: '15px', borderBottom: '1px solid #eee'}}>
                  <p style={{fontSize:'0.9rem', marginBottom:'5px', fontWeight:'bold'}}>1. Önce Yedek Al (İndir):</p>
                  <button 
                    onClick={verileriIndir} 
                    style={{
                      backgroundColor: '#27ae60', /* Yeşil Renk */
                      color: 'white',
                      padding: '12px',
                      border: 'none',
                      borderRadius: '8px',
                      width: '100%',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px'
                    }}
                  >
                    📥 Tüm Verileri Bilgisayara İndir
                  </button>
                </div>

                {/* 👇 2. DOSYA YÜKLEME BÖLÜMÜ (MEVCUT KODUN) 👇 */}
                <div style={{marginBottom:'20px'}}>
                   <p style={{fontSize:'0.9rem', marginBottom:'5px', fontWeight:'bold'}}>2. Toplu JSON Yükle:</p>
                   <input 
                     type="file" 
                     accept=".json" 
                     onChange={dosyaYukle} 
                     style={{border: '1px solid #ccc', padding: '10px', width: '100%', background: '#f1f2f6', borderRadius:'8px'}}
                   />
                  {/* 3. TEHLİKELİ BÖLGE (SİLME ALANI) - DÜZELTİLMİŞ HALİ */}
<div style={{marginTop:'30px', paddingTop:'20px', borderTop:'2px dashed #ffcccc'}}>
    <h4 style={{color:'#c0392b', margin:'0 0 10px 0', fontSize:'1rem'}}>🚨 Tehlikeli Bölge</h4>
    <p style={{fontSize:'0.85rem', color:'#555', marginBottom:'15px'}}>
        Bu işlem geri alınamaz. Veritabanındaki bütün tarifleri kalıcı olarak siler.
    </p>
    
    {/* DOĞRU DEĞİŞKEN: adminSilModali */}
    <button 
        onClick={() => setAdminSilModali(true)} 
        style={{
            width: '100%', padding: '12px', backgroundColor: '#fff5f5', color: '#c0392b',
            border: '1px solid #e74c3c', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer'
        }}
    >
        💣 Tüm Yemekleri Sil
    </button>
</div>

{/* SİLME ONAY PENCERESİ (MODAL) */}
{adminSilModali && (
    <div style={{
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 10001,
        display: 'flex', justifyContent: 'center', alignItems: 'center'
    }}>
        <div style={{
            backgroundColor: 'white', padding: '30px', borderRadius: '15px',
            textAlign: 'center', width: '90%', maxWidth: '350px',
            boxShadow: '0 0 20px rgba(255,0,0,0.5)'
        }}>
            <div style={{fontSize:'40px', marginBottom:'10px'}}>⚠️</div>
            <h3 style={{color:'#c0392b', margin:'0 0 10px 0'}}>Emin misin?</h3>
            <p style={{marginBottom:'20px', color:'#555'}}>
                <b>{yemekler.length} adet</b> yemek tarifi tamamen silinecek!
            </p>
            
            <div style={{display:'flex', gap:'10px'}}>
                <button 
                    onClick={() => setAdminSilModali(false)}
                    style={{flex:1, padding:'10px', borderRadius:'8px', border:'1px solid #ccc', cursor:'pointer', backgroundColor:'white'}}
                >
                    Vazgeç
                </button>
                <button 
                    onClick={() => { tumYemekleriSil(); setAdminSilModali(false); }}
                    style={{flex:1, padding:'10px', borderRadius:'8px', border:'none', cursor:'pointer', backgroundColor:'#c0392b', color:'white', fontWeight:'bold'}}
                >
                    EVET, SİL
                </button>
            </div>
        </div>
    </div>
)}
                </div>
              </div>
            )} 
          </div>
          
        </div>
      )}
      

      {/* FORM MODAL (Ekleme/Düzenleme) */}
      {formAcik && (
        <div className="modal-overlay">
          <div className="modal-content form-modal-content">
            <button className="close-btn" onClick={() => setFormAcik(false)}>×</button>
            <h2>{aktifDuzenlemeId ? "Tarifi Güncelle ✏️" : "Yeni Tarif Ekle ➕"}</h2>
            <form onSubmit={yemekKaydet} className="add-form">
              <input required placeholder="Yemek Adı" value={formVerisi.ad} onChange={e=>setFormVerisi({...formVerisi, ad:e.target.value})}/>
              {/* 👇 KATEGORİ SEÇİM KUTUSU BAŞLANGICI 👇 */}
<div style={{ marginBottom: "15px" }}>
  <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
    Kategori
  </label>
  <select
    value={formVerisi.kategori}
    onChange={(e) => setFormVerisi({ ...formVerisi, kategori: e.target.value })}
    style={{
      width: "100%",
      padding: "10px",
      borderRadius: "8px",
      border: "1px solid #ddd",
      backgroundColor: "#fff",
      fontSize: "16px",
    }}
  >
    <option value="Ana Yemek">Ana Yemek</option>
    <option value="Çorba">Çorba</option>
    <option value="Tatlı">Tatlı</option>
    <option value="Salata">Salata</option>
    <option value="Hamur İşi">Hamur İşi</option>
    <option value="İçecek">İçecek</option>
    <option value="Ara Öğün">Ara Öğün</option>
    <option value="Dünya Mutfağı">Dünya Mutfağı</option>
  </select>
</div>
{/* 👆 KATEGORİ SEÇİM KUTUSU BİTİŞİ 👆 */}
              <div className="row">
                 <select value={formVerisi.maliyet} onChange={e=>setFormVerisi({...formVerisi, maliyet:e.target.value})}>{maliyetSecenekleri.map(m=><option key={m} value={m}>{m} Maliyet</option>)}</select>
                 <select value={formVerisi.zorluk} onChange={e=>setFormVerisi({...formVerisi, zorluk:e.target.value})}><option>Kolay</option><option>Orta</option><option>Zor</option></select>
              </div>

              <div className="checkbox-group">{ogunSecenekleri.map(o=><label key={o} className={`check-label ${formVerisi.ogunler.includes(o)?'checked':''}`}><input type="checkbox" onChange={()=>handleCheckbox('ogunler',o)}/>{o}</label>)}</div>
              <div className="checkbox-group">{diyetSecenekleri.map(d=><label key={d} className={`check-label ${formVerisi.diyetler.includes(d)?'checked':''}`}><input type="checkbox" onChange={()=>handleCheckbox('diyetler',d)}/>{d}</label>)}</div>
              
              {/* 👇 EKSİK OLAN KİŞİ SAYISI BURAYA EKLENDİ 👇 */}
              <div className="row">
                <input type="number" placeholder="Süre (dk)" value={formVerisi.sure} onChange={e=>setFormVerisi({...formVerisi, sure:e.target.value})}/>
                <input type="number" placeholder="Kalori" value={formVerisi.kalori} onChange={e=>setFormVerisi({...formVerisi, kalori:e.target.value})}/>
                <input type="number" placeholder="Kişi Sayısı" value={formVerisi.kisiSayisi} onChange={e=>setFormVerisi({...formVerisi, kisiSayisi:e.target.value})}/>
              </div>

              <div className="row">
                <input type="number" placeholder="Prot (gr)" value={formVerisi.protein} onChange={e=>setFormVerisi({...formVerisi, protein:e.target.value})}/>
                <input type="number" placeholder="Karb (gr)" value={formVerisi.karbonhidrat} onChange={e=>setFormVerisi({...formVerisi, karbonhidrat:e.target.value})}/>
                <input type="number" placeholder="Yağ (gr)" value={formVerisi.yag} onChange={e=>setFormVerisi({...formVerisi, yag:e.target.value})}/>
              </div>

              <input placeholder="Resim URL" value={formVerisi.resim} onChange={e=>setFormVerisi({...formVerisi, resim:e.target.value})}/>
              <input placeholder="Video URL" value={formVerisi.video} onChange={e=>setFormVerisi({...formVerisi, video:e.target.value})}/>
              <textarea placeholder="Malzemeler (Malzeme: Miktar)" rows="5" value={formVerisi.malzemelerStr} onChange={e=>setFormVerisi({...formVerisi, malzemelerStr:e.target.value})}/>
              <textarea placeholder="Yapılış Adımları" rows="5" value={formVerisi.yapilisStr} onChange={e=>setFormVerisi({...formVerisi, yapilisStr:e.target.value})}/>
              <button type="submit" className="submit-btn full-width">{aktifDuzenlemeId ? "Değişiklikleri Kaydet" : "Tarifi Ekle"}</button>
            </form>
          </div>
          
        </div>
        
      )}

      {/* ------------------------------------------------------------------ */}
      {/* SAĞ ALTTAKİ EKLEME BUTONU (+) - SADECE ADMİNLER GÖREBİLİR          */}
      {/* ------------------------------------------------------------------ */}
      {kullanici && adminListesi.includes(kullanici.email) && !formAcik && (
        <button 
          onClick={() => {
            setFormVerisi({ 
              ad: '', sure: '', zorluk: 'Kolay', maliyet: 'Ucuz', 
              kalori: '', kisiSayisi: '', resim: '', video: '', 
              malzemelerStr: '', yapilisStr: '', ogunler: [], diyetler: [] 
            }); 
            setAktifDuzenlemeId(null); 
            setFormAcik(true);
          }} 
          className="fab-btn"
        >
          +
        </button>
      )}

      {/* ℹ️ GELİŞTİRİLMİŞ ÖLÇÜ REHBERİ MODALI */}
{olcuRehberiAcik && (
  <div className="modal-overlay" onClick={() => setOlcuRehberiAcik(false)}>
    <div className="modal-content" onClick={e => e.stopPropagation()} style={{maxWidth:'500px'}}>
      <button className="close-btn" onClick={() => setOlcuRehberiAcik(false)}>✕</button>
      <h2 style={{borderBottom:'2px solid #eee', paddingBottom:'10px'}}>📏 Mutfak Kısayolları</h2>
      
      <div style={{display:'flex', flexDirection:'column', gap:'15px', marginTop:'15px'}}>
        
        {/* BARDAKLAR */}
        <div style={{background:'#e3f2fd', padding:'10px', borderRadius:'8px'}}>
          <h4 style={{margin:'0 0 5px 0', color:'#1565c0'}}>🥛 Bardak Ölçüleri (200ml)</h4>
          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'5px', fontSize:'0.9rem'}}>
            <span>💧 Su / Süt:</span> <b>200 ml</b>
            <span>🌾 Un:</span> <b>~110 gr</b>
            <span>🍬 Şeker:</span> <b>~170 gr</b>
            <span>🍚 Pirinç:</span> <b>~180 gr</b>
            <span>🧴 Sıvı Yağ:</span> <b>~180 ml</b>
          </div>
        </div>

        {/* KAŞIKLAR */}
        <div style={{background:'#fff3e0', padding:'10px', borderRadius:'8px'}}>
          <h4 style={{margin:'0 0 5px 0', color:'#ef6c00'}}>🥄 Kaşık Ölçüleri (Tepeleme)</h4>
          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'5px', fontSize:'0.9rem'}}>
            <span>1 Yemek K. Un:</span> <b>~15 gr</b>
            <span>1 Yemek K. Şeker:</span> <b>~20 gr</b>
            <span>1 Yemek K. Salça:</span> <b>~25 gr</b>
            <span>1 Tatlı K. Tuz:</span> <b>~5 gr</b>
          </div>
        </div>

        {/* PRATİK TERİMLER */}
        <div style={{background:'#e8f5e9', padding:'10px', borderRadius:'8px'}}>
          <h4 style={{margin:'0 0 5px 0', color:'#2e7d32'}}>🤏 Pratik Terimler</h4>
          <ul style={{margin:0, paddingLeft:'20px', fontSize:'0.9rem'}}>
            <li><b>1 Tutam:</b> Baş, işaret ve orta parmağın ucuyla alınan miktar.</li>
            <li><b>1 Fiske:</b> Sadece baş ve işaret parmağı ucu.</li>
            <li><b>1 Diş:</b> Bir baş sarımsağın içinden çıkan tek parça.</li>
            <li><b>Göz Kararı:</b> Tarifi bozmuyorsa, sevdiğin kadar koy! 😄</li>
          </ul>
        </div>

      </div>
    </div>
  </div>
)}
{/* 👇👇 YENİ PANELİ TAM BURAYA YAPIŞTIR 👇👇 */}

      {/* -------------------------------------------------------------------------- */}
      {/* 👤 PROFİL & ADMİN PANELİ MODALI                                          */}
      {/* -------------------------------------------------------------------------- */}
      {panelAcik && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 9999,
          display: 'flex', justifyContent: 'center', alignItems: 'flex-start',
          overflowY: 'auto', paddingTop: '50px'
        }}>
          <div style={{
            backgroundColor: '#f8f9fa', width: '90%', maxWidth: '600px',
            borderRadius: '15px', padding: '25px', position: 'relative',
            boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
          }}>
            
            {/* ÜST MENÜ (NAVİGASYON) */}
            <div style={{display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #eee', paddingBottom: '10px'}}>
              
              {/* 1. GERİ DÖN BUTONU (Profil ve Hedeflere Gider) */}
              <button 
                onClick={() => { setPanelAcik(false); setProfilAcik(true); }} 
                style={{
                  flex: 1, padding: '10px', borderRadius: '8px', border: 'none', cursor: 'pointer',
                  backgroundColor: '#7f8c8d', // Gri Renk
                  color: 'white', fontWeight: 'bold', fontSize: '0.9rem'
                }}
              >
                ⬅ Profil ve Hedefler
              </button>

              {/* 2. YORUMLAR BUTONU (Listenin görünmesini sağlayan buton) */}
              <button 
                onClick={() => setAktifPanelTab('profil')} // <-- Bu komut yorumları getirir
                style={{
                  flex: 1, padding: '10px', borderRadius: '8px', border: 'none', cursor: 'pointer',
                  // Eğer admin değilse veya 'profil' seçiliyse MAVİ olsun
                  backgroundColor: aktifPanelTab === 'profil' ? '#3498db' : '#ecf0f1',
                  color: aktifPanelTab === 'profil' ? 'white' : '#555', fontWeight: 'bold', fontSize: '0.9rem'
                }}
              >
                💬 Yorumlar
              </button>

              {/* 3. ADMIN BUTONU (Varsa) */}
              {kullanici && adminListesi.includes(kullanici.email) && (
                <button 
                  onClick={() => setAktifPanelTab('admin')}
                  style={{
                    flex: 1, padding: '10px', borderRadius: '8px', border: 'none', cursor: 'pointer',
                    backgroundColor: aktifPanelTab === 'admin' ? '#c0392b' : '#ecf0f1',
                    color: aktifPanelTab === 'admin' ? 'white' : '#555', fontWeight: 'bold', fontSize: '0.9rem'
                  }}
                >
                  🛡️ Admin
                </button>
              )}
            </div>

            {/* --- İÇERİK KISMI --- */}
            <h3 style={{marginTop: 0, color:'#333', textAlign:'center', fontSize:'1.1rem'}}>
              {aktifPanelTab === 'profil' ? '📝 Geçmiş Yorumların' : '🚨 Şikayet Bildirimleri'}
            </h3>

            {/* LİSTELEME ALANI */}
            {panelYorumlari.length === 0 ? (
              <div style={{textAlign: 'center', padding: '30px', backgroundColor:'white', borderRadius:'10px'}}>
                <p style={{color: '#888', marginBottom:'10px'}}>Henüz listelenecek bir yorum yok.</p>
                {/* Eğer hata varsa kullanıcıya ipucu ver */}
                <small style={{color:'#ccc'}}>Panel Modu: {aktifPanelTab}</small>
              </div>
            ) : (
              <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
                {panelYorumlari.map((yorum) => (
                  <div key={yorum.id} style={{
                    backgroundColor: 'white', padding: '15px', borderRadius: '10px',
                    borderLeft: aktifPanelTab === 'admin' ? '5px solid #c0392b' : '5px solid #3498db',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
                  }}>
                    
                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '0.9rem', color: '#666'}}>
                      <strong>🥘 {yorum.recipeName || "Yemek İsmi Yok"}</strong>
                      <span>{yorum.createdAt?.seconds ? new Date(yorum.createdAt.seconds * 1000).toLocaleDateString('tr-TR') : ''}</span>
                    </div>

                    {aktifPanelTab === 'admin' && (
  <div style={{ backgroundColor: '#fff5f5', padding: '8px', borderRadius: '5px', marginBottom: '8px', border: '1px solid #ffcfcf' }}>
    {/* 1. ŞİKAYET EDEN (Yeni eklediğimiz alan) */}
    <div style={{fontSize: '0.8rem', color: '#c0392b', marginBottom: '3px'}}>
      🚩 <b>Şikayet Eden:</b> {yorum.bildirenKullaniciEmail || "Eski Kayıt"}
    </div>

    {/* 2. YORUMU YAZAN (Asıl Sahibi) */}
    <div style={{fontSize: '0.8rem', color: '#2c3e50'}}>
      👤 <b>Yorum Sahibi:</b> {yorum.userName}
    </div>
  </div>
)}

                    <div style={{fontSize: '1rem', color: '#333', marginBottom: '10px'}}>
                      <span style={{color: '#f1c40f'}}>{"⭐".repeat(yorum.rating)}</span> {yorum.text}
                    </div>

                    <div style={{display: 'flex', gap: '10px', justifyContent: 'flex-end'}}>
                      <button 
                        onClick={() => yorumSil(yorum.id)} 
                        style={{padding: '5px 10px', fontSize: '0.8rem', backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer'}}
                      >
                        🗑️ Sil
                      </button>
                      {/* ✅ YENİ: ŞİKAYETİ REDDET BUTONU */}
{yorum.isReported && (
 <button 
  onClick={async () => {
    try {
      const yorumRef = doc(db, "comments", yorum.id);
      
      // 1. Firebase güncellemesi
      await updateDoc(yorumRef, { isReported: false });

      // 2. 🔥 DOĞRU LİSTEYİ GÜNCELLE (panelYorumlari)
      setPanelYorumlari(onceki => onceki.filter(y => y.id !== yorum.id));

      // 3. BİLDİRİM
      bildirimGoster("Şikayet reddedildi ve listeden kaldırıldı.", "basari");
      
    } catch (hata) {
      console.error("Hata:", hata);
      bildirimGoster("İşlem sırasında bir hata oluştu.", "hata");
    }
  }}
  style={{
      padding: '5px 12px',
      fontSize: '0.8rem',
      backgroundColor: '#7f8c8d', // Koyu gri
      color: 'white',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      marginLeft: '5px'
    }}
>
  📁 Şikayeti Kapat
</button>
)}
                    </div>
                    
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* 👆👆 YENİ PANEL BURADA BİTİYOR 👆👆 */}
{/* ✅ ÖZEL SİLME ONAY PANELİ (En alta, App kapanmadan hemen önce) */}
      
    {/* --- BURAYI return (...) KISMININ EN ALTINA YAPIŞTIR --- */}
      
      {onayModal.goster && (
        <div className="confirm-overlay" style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 999999, // En üstte olsun
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            backdropFilter: 'blur(5px)'
        }}>
            <div className="confirm-box" style={{
                backgroundColor: '#1e1e1e', padding: '25px', borderRadius: '15px',
                width: '90%', maxWidth: '400px', textAlign: 'center', border: '1px solid #333',
                boxShadow: '0 10px 40px rgba(0,0,0,0.5)', color: 'white'
            }}>
                <h3 style={{color: '#ff4757', marginTop: 0}}>{onayModal.baslik}</h3>
                <p style={{fontSize: '1.1rem', color: '#ddd', margin: '20px 0'}}>{onayModal.mesaj}</p>
                
                <div style={{display: 'flex', gap: '15px', justifyContent: 'center'}}>
                    <button 
                        onClick={() => setOnayModal({...onayModal, goster: false})}
                        style={{padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#57606f', color: 'white', cursor: 'pointer', fontWeight: 'bold'}}
                    >
                        Vazgeç
                    </button>
                    <button 
                        onClick={onayiOnayla}
                        style={{padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#ff4757', color: 'white', cursor: 'pointer', fontWeight: 'bold'}}
                    >
                        Evet, Onayla
                    </button>
                </div>
            </div>
        </div>
      )}
      
      {/* --- BURAYA KADAR --- */}


{(ilkGirisZorunlu || hakkindaAcik) && (
  <HakkindaModal 
    zorunluMu={ilkGirisZorunlu}
    kapat={async () => {

      console.log("🟢 Modal kapatılıyor...");

      // ilk girişse localStorage'a yaz
      if (ilkGirisZorunlu) {
        localStorage.setItem('yasalUyariOnayi', 'true');
        setIlkGirisZorunlu(false);
      }

      // her durumda modalı kapat
      setHakkindaAcik(false);

      // 👇 sadece ilk girişte URL tarif yükle
      if (ilkGirisZorunlu) {
        const params = new URLSearchParams(window.location.search);
        const urlId = params.get('recipeId'); 

        if (urlId) {
          console.log("🚀 Onay sonrası tarif yükleniyor:", urlId);
          const basarili = await tarifGetir(urlId);

          if (basarili) {
            console.log("✅ Tarif yüklendi");
          } else {
            console.warn("⚠️ Tarif yüklenemedi");
          }
        }
      }
    }}
  />
)}

      {/* ALT TAB BAR - 3'LÜ VERSİYON */}
<div style={{
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  height: '70px',
  backgroundColor: 'var(--card-bg)',
  boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  zIndex: 999,
  borderTop: '1px solid #eee'
}}>
  
  {/* ANA SAYFA */}
  <button 
    onClick={() => setAktifSekme("ana")}
    style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '5px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: aktifSekme === "ana" ? 'var(--primary)' : '#999',
      transition: '0.2s',
      padding: '10px'
    }}
  >
    <span style={{fontSize: '1.5rem'}}>{aktifSekme === "ana" ? '🏠' : '🏘️'}</span>
    <span style={{fontSize: '0.75rem', fontWeight: aktifSekme === "ana" ? 'bold' : 'normal'}}>
      Ana Sayfa
    </span>
  </button>
  
  {/* FAVORİLER */}
  <button 
    onClick={() => setAktifSekme("favoriler")}
    style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '5px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: aktifSekme === "favoriler" ? 'var(--primary)' : '#999',
      transition: '0.2s',
      padding: '10px'
    }}
  >
    <span style={{fontSize: '1.5rem'}}>{aktifSekme === "favoriler" ? '❤️' : '🤍'}</span>
    <span style={{fontSize: '0.75rem', fontWeight: aktifSekme === "favoriler" ? 'bold' : 'normal'}}>
      Favoriler
    </span>
  </button>
  
  {/* AYARLAR */}
  <button 
    onClick={() => setAktifSekme("ayarlar")}
    style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '5px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      color: aktifSekme === "ayarlar" ? 'var(--primary)' : '#999',
      transition: '0.2s',
      padding: '10px'
    }}
  >
    <span style={{fontSize: '1.5rem'}}>⚙️</span>
    <span style={{fontSize: '0.75rem', fontWeight: aktifSekme === "ayarlar" ? 'bold' : 'normal'}}>
      Ayarlar
    </span>
  </button>
  
</div>
    </div> // <-- App Kapanışı
    
  );
}

// 👇 HAKKINDA / YASAL UYARI PENCERESİ BİLEŞENİ
// 👇 EN OKUNAKLI VE YASAL OLARAK GÜVENLİ VERSİYON
const HakkindaModal = ({ kapat, zorunluMu }) => {
  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0, width: "100%", height: "100%",
      backgroundColor: "rgba(0,0,0,0.9)", // Arka plan simsiyah, odak sadece metinde
      display: "flex", justifyContent: "center", alignItems: "center",
      zIndex: 10000,
      backdropFilter: "blur(5px)"
    }}>
      <div style={{
        backgroundColor: "#ffffff", 
        width: "90%", 
        maxWidth: "500px", // Genişliği biraz artırdık
        maxHeight: "85vh", // Ekranın %85'i kadar boy
        borderRadius: "16px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden", 
        boxShadow: "0 25px 60px rgba(0,0,0,0.7)"
      }}>
        
        {/* --- BAŞLIK --- */}
        <div style={{ padding: "20px", borderBottom: "2px solid #f1f1f1", backgroundColor: "#fafafa" }}>
           {!zorunluMu && (
            <button 
              onClick={kapat}
              style={{
                float: "right", background: "#eee", border: "none", borderRadius: "50%",
                width: "35px", height: "35px", fontSize: "18px", color: "#333", cursor: "pointer", fontWeight: "bold"
              }}>✕</button>
          )}
          <h2 style={{ margin: 0, color: "#c0392b", fontSize: "1.4rem", textAlign: "center", fontWeight: "800" }}>
             ⚠️ YASAL UYARI
          </h2>
        </div>

        {/* --- OKUNAKLI METİN ALANI --- */}
        <div style={{ 
          padding: "25px", 
          overflowY: "auto", 
          flex: 1, 
          fontSize: "15px", // ✅ İDEAL OKUMA BOYUTU
          lineHeight: "1.7", // ✅ SATIRLAR RAHAT
          color: "#222", // ✅ KOYU VE NET RENK
          fontFamily: "sans-serif"
        }}>
          <p style={{fontWeight: "bold", marginBottom: "20px", color: "#000", borderLeft: "4px solid #c0392b", paddingLeft: "10px", backgroundColor: "#fff5f5"}}>
            Lütfen uygulamayı kullanmadan önce bu metni dikkatlice okuyunuz. Devam etmeniz, tüm şartları kabul ettiğiniz anlamına gelir.
          </p>
          
          <h3 style={{fontSize: "1.1rem", marginBottom: "5px", color: "#000", borderBottom: "1px solid #ddd", paddingBottom: "5px"}}>
            1. TIBBİ TAVSİYE DEĞİLDİR 🏥
          </h3>
          <p style={{marginBottom: "20px"}}>
            Bu uygulamadaki tarifler, kalori hesapları ve diyet etiketleri (Glutensiz, Fit vb.) sadece genel bilgi amaçlıdır. <strong>Doktor veya diyetisyen tavsiyesi yerine geçmez.</strong> Sağlığınızla ilgili konularda mutlaka uzmana danışınız.
          </p>

          <h3 style={{fontSize: "1.1rem", marginBottom: "5px", color: "#000", borderBottom: "1px solid #ddd", paddingBottom: "5px"}}>
            2. ALERJİ VE SAĞLIK RİSKİ 🥜
          </h3>
          <p style={{marginBottom: "20px"}}>
            Malzemelerin içeriğini kontrol etmek sizin sorumluluğunuzdadır. Alerjik reaksiyon, gıda zehirlenmesi veya mide rahatsızlıklarından <strong>uygulama sahibi sorumlu tutulamaz.</strong>
          </p>

          <h3 style={{fontSize: "1.1rem", marginBottom: "5px", color: "#000", borderBottom: "1px solid #ddd", paddingBottom: "5px"}}>
            3. VERİ HATALARI VE YAPAY ZEKA 🤖
          </h3>
          <p style={{marginBottom: "20px"}}>
            İçerikler yapay zeka desteğiyle üretilmiştir. Malzeme miktarlarında veya besin değerlerinde hata olabilir. Lütfen uygulamadan önce verileri kendi süzgecinizden geçiriniz.
          </p>

          <h3 style={{fontSize: "1.1rem", marginBottom: "5px", color: "#000", borderBottom: "1px solid #ddd", paddingBottom: "5px"}}>
            4. KABUL VE ONAY ✅
          </h3>
          <p style={{marginBottom: "10px"}}>
            Uygulamayı kullanarak, tarifleri kendi hür iradenizle ve riskleri size ait olmak üzere uyguladığınızı kabul etmiş sayılırsınız.
          </p>
        </div>

        {/* --- BÜYÜK ONAY BUTONU --- */}
        <div style={{ padding: "20px", borderTop: "1px solid #eee", backgroundColor: "#fff" }}>
          <button 
            onClick={kapat}
            style={{
              width: "100%",
              padding: "16px",
              backgroundColor: "#27ae60",
              color: "white",
              border: "none",
              borderRadius: "10px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: "0 5px 15px rgba(39, 174, 96, 0.4)",
              transition: "0.2s"
            }}
          >
            OKUDUM, ANLADIM VE KABUL EDİYORUM
          </button>
        </div>

      </div>
    </div>
  );
};

export default App;